<template>
  <vuetify-wrapper>
    <div class="carteira-kanban-vue">
      <div class="carteira-kanban-vue__bootstrap-modals">
        <Modal
          modal-id="modalCarteiraKanbanFaseErro"
          :title="faseErrorModalTitle"
          dialog-class="modal-dialog-centered"
        >
          <template #body>
            <p v-if="faseErrorModalMessage" class="mb-2">{{ faseErrorModalMessage }}</p>
            <ul
              v-if="faseErrorModalItems.length"
              class="list-unstyled mb-0 carteira-cadastros-vue__error-list"
            >
              <li v-for="(row, i) in faseErrorModalItems" :key="i" class="small">
                <template v-if="row.label">
                  <strong>{{ row.label }}:</strong>
                  {{ row.text }}
                </template>
                <template v-else>{{ row.text }}</template>
              </li>
            </ul>
          </template>
          <template #footer>
            <button type="button" class="btn btn-primary btn-sm" @click="closeFaseErrorModal">Fechar</button>
          </template>
        </Modal>

        <Modal
          modal-id="modalCarteiraKanbanFaseExcluir"
          title="Excluir coluna"
          dialog-class="modal-dialog-centered"
        >
          <template #body>
            <template v-if="faseDeleteTarget">
              <p class="mb-2">
                Excluir a coluna <strong>{{ faseDeleteTarget.nome }}</strong>?
              </p>
              <template v-if="faseDeleteDestinoOpcoes.length">
                <p class="text-muted small mb-2">
                  <template v-if="faseDeleteTarget.total > 0">
                    {{ faseDeleteTarget.total }} cliente(s) nesta coluna serão movidos para:
                  </template>
                  <template v-else>
                    Se houver clientes nesta coluna, eles serão movidos para:
                  </template>
                </p>
                <div class="form-group mb-0">
                  <label class="small mb-1" for="carteira-kanban-fase-delete-destino">Coluna de destino</label>
                  <select
                    id="carteira-kanban-fase-delete-destino"
                    v-model.number="faseDeleteMigrarParaId"
                    class="form-control form-control-sm"
                    :disabled="faseDeleteLoading"
                  >
                    <option
                      v-for="opt in faseDeleteDestinoOpcoes"
                      :key="opt.id"
                      :value="opt.id"
                    >{{ opt.nome }}</option>
                  </select>
                </div>
              </template>
              <p v-else-if="faseDeleteTarget.total > 0" class="text-warning small mb-0">
                Crie outra coluna antes de excluir esta, para onde mover os clientes.
              </p>
              <p v-else class="text-muted small mb-0">Esta coluna não possui clientes no momento.</p>
            </template>
          </template>
          <template #footer>
            <Button
              variant="danger"
              size="sm"
              :loading="faseDeleteLoading"
              :disabled="!faseDeletePodeConfirmar"
              @click="executeDeleteFase"
            >
              {{ faseDeleteLoading ? "Excluindo…" : "Excluir" }}
            </Button>
            <button
              type="button"
              class="btn btn-secondary btn-sm ml-2"
              :disabled="faseDeleteLoading"
              data-dismiss="modal"
              @click="closeDeleteFaseModal"
            >
              Cancelar
            </button>
          </template>
        </Modal>

        <Modal
          modal-id="modalCarteiraKanbanOportunidades"
          :title="oportunidadePickerModalTitle"
          dialog-class="modal-dialog-centered modal-lg"
        >
          <template #body>
            <div v-if="oportunidadePickerCard" class="carteira-kanban-vue__oportunidade-picker-head mb-3">
              <p class="text-muted small mb-0">
                Conta <strong>{{ displayNome(oportunidadePickerCard) }}</strong>
                <span v-if="oportunidadePickerHeadCount" class="ml-1">
                  · {{ oportunidadePickerHeadCount }}
                  {{ oportunidadePickerHeadCount === 1 ? "oportunidade" : "oportunidades" }}
                  <span v-if="oportunidadePickerHeadValor != null">
                    · {{ formatCurrency(oportunidadePickerHeadValor) }}
                  </span>
                </span>
              </p>
            </div>
            <ul class="nav nav-tabs mb-3" role="tablist">
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  :class="{ active: oportunidadePickerAba === 'abertas' }"
                  role="tab"
                  @click.prevent="setOportunidadePickerAba('abertas')"
                >Em aberto</a>
              </li>
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  :class="{ active: oportunidadePickerAba === 'encerradas' }"
                  role="tab"
                  @click.prevent="setOportunidadePickerAba('encerradas')"
                >Encerradas</a>
              </li>
            </ul>
            <p v-if="oportunidadePickerTabErro" class="text-danger small">{{ oportunidadePickerTabErro }}</p>
            <div
              v-if="oportunidadePickerTabLoading"
              class="carteira-kanban-vue__column-loading py-4"
              aria-live="polite"
              aria-busy="true"
            >
              <div class="carteira-kanban-vue__column-loading-inner">
                <div class="carteira-kanban-vue__loading-spinner carteira-kanban-vue__loading-spinner--sm" aria-hidden="true">
                  <span></span><span></span><span></span>
                </div>
                <span>Carregando oportunidades…</span>
              </div>
            </div>
            <div v-else-if="oportunidadePickerListaAtual.length" class="carteira-kanban-vue__oportunidade-picker">
              <button
                v-for="op in oportunidadePickerListaAtual"
                :key="op.id"
                type="button"
                class="carteira-kanban-vue__oportunidade-card"
                @click="abrirOportunidade(op)"
              >
                <div class="carteira-kanban-vue__oportunidade-card-top">
                  <span class="carteira-kanban-vue__oportunidade-card-title">{{ op.nome }}</span>
                  <span class="carteira-kanban-vue__oportunidade-card-actions">
                    <span
                      v-if="op.mensagens_nao_lidas > 0"
                      class="carteira-kanban-vue__oportunidade-card-badge"
                      :title="op.mensagens_nao_lidas + ' mensagem(ns) não lida(s)'"
                    >{{ mensagensNaoLidasBadge(op.mensagens_nao_lidas) }}</span>
                    <i class="fas fa-arrow-right carteira-kanban-vue__oportunidade-card-arrow" aria-hidden="true"></i>
                  </span>
                </div>
                <div v-if="op.valor_formatado" class="carteira-kanban-vue__oportunidade-card-valor">
                  {{ op.valor_formatado }}
                </div>
                <div v-if="op.pipeline_nome || op.fase_nome" class="carteira-kanban-vue__oportunidade-card-chips">
                  <span v-if="op.pipeline_nome" class="carteira-kanban-vue__oportunidade-chip carteira-kanban-vue__oportunidade-chip--pipeline">
                    <i class="fas fa-stream" aria-hidden="true"></i>
                    {{ op.pipeline_nome }}
                  </span>
                  <span
                    v-if="op.fase_nome"
                    class="carteira-kanban-vue__oportunidade-chip carteira-kanban-vue__oportunidade-chip--fase"
                    :style="opFaseChipStyle(op)"
                  >
                    {{ op.fase_nome }}
                  </span>
                </div>
                <div class="carteira-kanban-vue__oportunidade-card-meta">
                  <span v-if="op.status_nome" class="carteira-kanban-vue__oportunidade-meta-item">
                    <i class="fas fa-circle-notch" aria-hidden="true"></i>
                    {{ op.status_nome }}
                  </span>
                  <span v-if="opCanalLabel(op)" class="carteira-kanban-vue__oportunidade-meta-item">
                    <i :class="opCanalIconClass(op)" aria-hidden="true"></i>
                    {{ opCanalLabel(op) }}
                  </span>
                  <span v-if="op.atendente_nome" class="carteira-kanban-vue__oportunidade-meta-item">
                    <i class="fas fa-user" aria-hidden="true"></i>
                    {{ op.atendente_nome }}
                  </span>
                  <span v-if="op.cliente_nome" class="carteira-kanban-vue__oportunidade-meta-item">
                    <i class="fas fa-address-card" aria-hidden="true"></i>
                    {{ op.cliente_nome }}
                  </span>
                  <span v-if="op.created_at_label" class="carteira-kanban-vue__oportunidade-meta-item">
                    <i class="far fa-calendar-alt" aria-hidden="true"></i>
                    {{ op.created_at_label }}
                  </span>
                </div>
              </button>
            </div>
            <p v-else class="text-muted small mb-0">{{ oportunidadePickerEmptyText }}</p>
            <div
              v-if="oportunidadePickerAba === 'encerradas' && oportunidadeEncerradasHasMore"
              class="text-center mt-3"
            >
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                :disabled="oportunidadeEncerradasLoadingMore"
                @click="carregarMaisOportunidadesEncerradas"
              >
                <i
                  :class="oportunidadeEncerradasLoadingMore ? 'fas fa-circle-notch fa-spin' : 'fas fa-plus'"
                  class="mr-1"
                  aria-hidden="true"
                ></i>
                Carregar mais
              </button>
            </div>
          </template>
          <template #footer>
            <button
              v-if="podeCriarOportunidade && oportunidadePickerAba === 'abertas'"
              type="button"
              class="btn btn-primary btn-sm mr-auto"
              :disabled="oportunidadeCriando"
              @click="criarOportunidadeKanban"
            >
              <i
                :class="[
                  oportunidadeCriando ? 'fas fa-circle-notch fa-spin' : 'fas fa-plus',
                  'mr-1',
                ]"
                aria-hidden="true"
              ></i>
              Nova oportunidade
            </button>
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
          </template>
        </Modal>

        <Modal
          modal-id="modalCarteiraKanbanTarefas"
          :title="tarefaPickerModalTitle"
          dialog-class="modal-dialog-centered modal-lg"
        >
          <template #body>
            <template v-if="tarefaPickerCard">
              <div class="carteira-kanban-vue__tarefa-picker-head mb-3">
                <p class="text-muted small mb-0">
                  Conta <strong>{{ displayNome(tarefaPickerCard) }}</strong>
                  <span v-if="tarefaPickerAba === 'tarefas' && tarefaPickerAbertas.length" class="ml-1">
                    · {{ tarefaPickerAbertas.length }}
                    {{ tarefaPickerAbertas.length === 1 ? "tarefa aberta" : "tarefas abertas" }}
                  </span>
                  <span v-else-if="tarefaPickerAba === 'notas' && tarefaNotasTotal" class="ml-1">
                    · {{ tarefaNotasTotal }}
                    {{ tarefaNotasTotal === 1 ? "nota" : "notas" }}
                  </span>
                </p>
              </div>

              <ul class="nav nav-tabs mb-3" role="tablist">
                <li class="nav-item">
                  <a
                    href="#"
                    class="nav-link"
                    :class="{ active: tarefaPickerAba === 'tarefas' }"
                    role="tab"
                    @click.prevent="setTarefaPickerAba('tarefas')"
                  >Tarefas</a>
                </li>
                <li class="nav-item">
                  <a
                    href="#"
                    class="nav-link"
                    :class="{ active: tarefaPickerAba === 'notas' }"
                    role="tab"
                    @click.prevent="setTarefaPickerAba('notas')"
                  >Notas</a>
                </li>
              </ul>

              <div v-show="tarefaPickerAba === 'tarefas'">
              <div
                v-if="tarefaPickerLoading"
                key="tarefa-picker-loading"
                class="carteira-kanban-vue__tarefa-picker-loading text-center py-4 text-muted small"
              >
                <i class="fas fa-circle-notch fa-spin mr-1" aria-hidden="true"></i>
                Carregando tarefas…
              </div>

              <div v-else key="tarefa-picker-content">
              <p v-if="tarefaPickerErro" class="text-danger small">{{ tarefaPickerErro }}</p>

              <div v-if="tarefaPickerPodeCriar" class="carteira-kanban-vue__tarefa-nova mb-3">
                <button
                  v-if="!tarefaPickerShowForm"
                  type="button"
                  class="btn btn-link btn-sm p-0"
                  @click="abrirFormTarefaKanban"
                >
                  <i class="fas fa-plus mr-1" aria-hidden="true"></i>
                  Nova tarefa
                </button>
                <form
                  v-else
                  class="carteira-kanban-vue__tarefa-form"
                  novalidate
                  @submit.prevent="salvarTarefaKanban"
                >
                  <div
                    v-if="tarefaPickerMostraSeletorContato"
                    class="form-group mb-2"
                  >
                    <label class="small mb-1" for="kanban-tarefa-cliente">Contato *</label>
                    <select
                      id="kanban-tarefa-cliente"
                      v-model="tarefaPickerForm.cliente_id"
                      class="custom-select custom-select-sm"
                      required
                      @change="onTarefaKanbanContatoChange"
                    >
                      <option
                        v-for="c in tarefaPickerContatos"
                        :key="c.id"
                        :value="String(c.id)"
                      >
                        {{ c.is_conta_pai ? `Conta: ${c.nome}` : c.nome }}
                      </option>
                    </select>
                  </div>
                  <div class="form-row">
                    <div class="col-md-8">
                      <Input
                        v-model="tarefaPickerForm.titulo"
                        name="kanban_tarefa_titulo"
                        id="kanban-tarefa-titulo"
                        label="Título *"
                        required
                        input-class="form-control-sm"
                        classe="mb-2"
                        placeholder="Título da tarefa"
                      />
                    </div>
                    <div class="col-md-4">
                      <div class="form-group mb-2">
                        <label class="small mb-1" for="kanban-tarefa-tipo">Tipo *</label>
                        <select
                          id="kanban-tarefa-tipo"
                          v-model="tarefaPickerForm.tipo"
                          class="custom-select custom-select-sm"
                          required
                        >
                          <option value="">Selecione</option>
                          <option
                            v-for="t in tarefaPickerFormMeta.tipos"
                            :key="t.id"
                            :value="t.id"
                          >{{ t.value }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group mb-2">
                        <label class="small mb-1" for="kanban-tarefa-user">Atribuído a *</label>
                        <select
                          id="kanban-tarefa-user"
                          v-model="tarefaPickerForm.user_id"
                          class="custom-select custom-select-sm"
                          required
                        >
                          <option
                            v-for="u in tarefaPickerFormMeta.users"
                            :key="u.id"
                            :value="u.id"
                          >{{ u.value }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <Input
                        v-model="tarefaPickerForm.data"
                        name="kanban_tarefa_data"
                        id="kanban-tarefa-data"
                        label="Data *"
                        type="date"
                        required
                        input-class="form-control-sm"
                        classe="mb-2"
                      />
                    </div>
                    <div class="col-md-3">
                      <Input
                        v-model="tarefaPickerForm.hora"
                        name="kanban_tarefa_hora"
                        id="kanban-tarefa-hora"
                        label="Hora *"
                        type="time"
                        required
                        input-class="form-control-sm"
                        classe="mb-2"
                      />
                    </div>
                  </div>
                  <div v-if="tarefaPickerFormWhatsapp" class="form-group mb-2">
                    <label class="small mb-1" for="kanban-tarefa-template">Mensagem de ativação *</label>
                    <select
                      id="kanban-tarefa-template"
                      v-model="tarefaPickerForm.template_id"
                      class="custom-select custom-select-sm"
                      :required="tarefaPickerFormWhatsapp"
                    >
                      <option value="">Selecione</option>
                      <option
                        v-for="tpl in tarefaPickerTemplatesWhatsapp"
                        :key="tpl.id"
                        :value="tpl.id"
                        :title="tpl.value"
                      >{{ tpl.label }}</option>
                    </select>
                  </div>
                  <Input
                    v-model="tarefaPickerForm.descricao"
                    name="kanban_tarefa_descricao"
                    id="kanban-tarefa-descricao"
                    label="Descrição"
                    input-class="form-control-sm"
                    classe="mb-2"
                    placeholder="Descrição da tarefa"
                  />
                  <p v-if="tarefaPickerErro" class="text-danger small mb-2">{{ tarefaPickerErro }}</p>
                  <div class="d-flex justify-content-end">
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm mr-2"
                      :disabled="tarefaPickerSaving"
                      @click="cancelarFormTarefaKanban"
                    >
                      Cancelar
                    </button>
                    <Button
                      variant="primary"
                      size="sm"
                      :loading="tarefaPickerSaving"
                      @click="salvarTarefaKanban"
                    >
                      Salvar tarefa
                    </Button>
                  </div>
                </form>
              </div>

              <div v-if="tarefaPickerListaExibicao.length" class="carteira-kanban-vue__tarefa-picker">
                <div
                  v-for="t in tarefaPickerListaExibicao"
                  :key="t.id"
                  class="carteira-kanban-vue__tarefa-card"
                  :class="{
                    'carteira-kanban-vue__tarefa-card--concluida': t.concluida,
                    'carteira-kanban-vue__tarefa-card--atrasada': t.atrasada,
                  }"
                >
                  <div class="carteira-kanban-vue__tarefa-card-top">
                    <span class="carteira-kanban-vue__tarefa-card-title">{{ t.titulo }}</span>
                    <div class="carteira-kanban-vue__tarefa-card-actions">
                      <span class="carteira-kanban-vue__tarefa-card-badge">{{ t.tipo_label }}</span>
                      <button
                        v-if="!t.concluida && t.pode_concluir"
                        type="button"
                        class="btn btn-outline-success btn-xs carteira-kanban-vue__tarefa-concluir-btn"
                        :disabled="tarefaConcluindoId === t.id"
                        :title="tarefaConcluindoId === t.id ? 'Salvando…' : 'Marcar como concluída'"
                        @click.stop="concluirTarefaKanban(t)"
                      >
                        <i
                          :class="tarefaConcluindoId === t.id ? 'fas fa-circle-notch fa-spin' : 'fas fa-check'"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                  </div>
                  <div class="carteira-kanban-vue__tarefa-card-meta">
                    <span class="carteira-kanban-vue__tarefa-meta-item">
                      <i class="far fa-calendar-alt" aria-hidden="true"></i>
                      {{ t.data_formatada }} às {{ t.hora_formatada }}
                    </span>
                    <span v-if="t.user_nome" class="carteira-kanban-vue__tarefa-meta-item">
                      <i class="fas fa-user" aria-hidden="true"></i>
                      {{ t.user_nome }}
                    </span>
                    <span v-if="t.cliente_nome" class="carteira-kanban-vue__tarefa-meta-item">
                      <i class="fas fa-address-card" aria-hidden="true"></i>
                      {{ t.cliente_nome }}
                    </span>
                    <span v-if="t.concluida" class="carteira-kanban-vue__tarefa-meta-item text-success">
                      <i class="fas fa-check-circle" aria-hidden="true"></i>
                      Concluída
                    </span>
                    <span v-else-if="t.atrasada" class="carteira-kanban-vue__tarefa-meta-item text-danger">
                      Atrasada
                    </span>
                    <span v-else-if="t.hoje" class="carteira-kanban-vue__tarefa-meta-item text-warning">
                      Hoje
                    </span>
                  </div>
                  <p v-if="t.descricao" class="carteira-kanban-vue__tarefa-card-desc small text-muted mb-0">
                    {{ t.descricao }}
                  </p>
                  <div v-if="t.oportunidade_id && t.oportunidade_nome" class="small mt-1">
                    <a
                      href="javascript:void(0)"
                      class="carteira-kanban-vue__tarefa-opp-link"
                      @click.prevent="abrirOportunidadeDaTarefa(t)"
                    >{{ t.oportunidade_nome }}</a>
                  </div>
                </div>
              </div>
              <p v-else class="text-muted small mb-0">Nenhuma tarefa cadastrada.</p>

              <button
                v-if="tarefaPickerConcluidas.length"
                type="button"
                class="btn btn-link btn-xs mt-2 p-0"
                @click="tarefaPickerVerConcluidas = !tarefaPickerVerConcluidas"
              >
                {{ tarefaPickerVerConcluidas ? "Ocultar concluídas" : `Ver concluídas (${tarefaPickerConcluidas.length})` }}
              </button>
              </div>
              </div>

              <div v-if="tarefaPickerAba === 'notas'">
                <p v-if="tarefaNotasErro" class="text-danger small">{{ tarefaNotasErro }}</p>
                <div
                  v-if="tarefaNotasLoading && !tarefaNotas.length"
                  class="carteira-kanban-vue__tarefa-picker-loading text-center py-4 text-muted small"
                >
                  <i class="fas fa-circle-notch fa-spin mr-1" aria-hidden="true"></i>
                  Carregando notas…
                </div>
                <div v-else>
                  <div v-if="tarefaNotas.length" class="carteira-kanban-vue__tarefa-picker">
                    <div
                      v-for="n in tarefaNotas"
                      :key="n.origem + '-' + n.id"
                      class="carteira-kanban-vue__tarefa-card"
                    >
                      <div class="carteira-kanban-vue__tarefa-card-top">
                        <span class="carteira-kanban-vue__tarefa-card-title">{{ notaOrigemLabel(n) }}</span>
                        <span class="carteira-kanban-vue__tarefa-card-badge">
                          {{ n.origem === 'oportunidade' ? 'Oportunidade' : 'Cliente' }}
                        </span>
                      </div>
                      <div class="carteira-kanban-vue__tarefa-card-meta">
                        <span v-if="n.created_at_label" class="carteira-kanban-vue__tarefa-meta-item">
                          <i class="far fa-calendar-alt" aria-hidden="true"></i>
                          {{ n.created_at_label }}
                        </span>
                        <span v-if="n.user_nome" class="carteira-kanban-vue__tarefa-meta-item">
                          <i class="fas fa-user" aria-hidden="true"></i>
                          {{ n.user_nome }}
                        </span>
                      </div>
                      <p class="carteira-kanban-vue__tarefa-card-desc carteira-kanban-vue__nota-texto small mb-0">
                        {{ n.texto }}
                      </p>
                      <div v-if="n.origem === 'oportunidade' && n.oportunidade_id" class="small mt-1">
                        <a
                          href="javascript:void(0)"
                          class="carteira-kanban-vue__tarefa-opp-link"
                          @click.prevent="abrirOportunidadeDaTarefa(n)"
                        >{{ n.oportunidade_nome || ('Oportunidade #' + n.oportunidade_id) }}</a>
                      </div>
                    </div>
                  </div>
                  <p v-else class="text-muted small mb-0">Nenhuma nota cadastrada.</p>
                  <div v-if="tarefaNotasHasMore" class="text-center mt-3">
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm"
                      :disabled="tarefaNotasLoadingMore"
                      @click="carregarMaisNotasKanban"
                    >
                      <i
                        :class="tarefaNotasLoadingMore ? 'fas fa-circle-notch fa-spin' : 'fas fa-plus'"
                        class="mr-1"
                        aria-hidden="true"
                      ></i>
                      Carregar mais
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template #footer>
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
          </template>
        </Modal>

        <Modal
          modal-id="modalCarteiraKanbanAdicionarClientes"
          :title="adicionarClientesModalTitle"
          dialog-class="modal-dialog-centered modal-lg"
        >
          <template #body>
            <div v-if="adicionarClientesCol">
              <p class="text-muted small mb-2">
                Contas sem dono ou já suas, que ainda não estão nesta coluna.
              </p>
              <div class="form-group mb-2">
                <label class="small mb-1" for="carteira-kanban-adicionar-busca">Buscar</label>
                <div class="input-group input-group-sm">
                  <input
                    id="carteira-kanban-adicionar-busca"
                    v-model="adicionarClientesBusca"
                    type="search"
                    class="form-control"
                    placeholder="Nome, e-mail ou telefone…"
                    autocomplete="off"
                    @keyup.enter="buscarClientesElegiveis"
                  />
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      :disabled="adicionarClientesLoading"
                      @click="buscarClientesElegiveis"
                    >
                      Buscar
                    </button>
                  </div>
                </div>
              </div>
              <p
                v-show="adicionarClientesLoading && !adicionarClientesListaExibida.length"
                class="text-center text-muted py-4 small mb-0"
              >
                <i class="fas fa-circle-notch fa-spin mr-1"></i> Buscando clientes…
              </p>
              <p v-show="adicionarClientesErro" class="text-danger small mb-2">
                {{ adicionarClientesErro }}
              </p>
              <p
                v-show="!adicionarClientesLoading && !adicionarClientesListaExibida.length && !adicionarClientesErro"
                class="text-muted small mb-2"
              >
                Nenhum cliente encontrado para adicionar nesta coluna.
              </p>
              <div
                v-show="adicionarClientesListaExibida.length > 0"
                class="carteira-kanban-vue__adicionar-list"
              >
                <label
                  v-for="row in adicionarClientesListaExibida"
                  :key="'add-cli-' + row.id"
                  class="carteira-kanban-vue__adicionar-item d-flex align-items-start"
                  :class="{ 'carteira-kanban-vue__adicionar-item--fixado': isAdicionarClienteForaDaBusca(row.id) }"
                >
                  <input
                    type="checkbox"
                    class="mt-1 mr-2"
                    :checked="isAdicionarClienteSelected(row.id)"
                    @change="toggleAdicionarCliente(row)"
                  />
                  <span class="flex-grow-1">
                    <span class="d-block font-weight-bold small">{{ displayNome(row) }}</span>
                    <span v-if="row.grupo_nome" class="d-block carteira-kanban-vue__meta">{{ row.grupo_nome }}</span>
                    <span class="d-block carteira-kanban-vue__meta">
                      <template v-if="row.sem_dono">Sem dono</template>
                      <template v-else-if="row.dono_nome">Dono: {{ row.dono_nome }}</template>
                      <template v-if="row.fase_atual_nome"> · Coluna atual: {{ row.fase_atual_nome }}</template>
                    </span>
                  </span>
                </label>
              </div>
              <button
                v-if="adicionarClientesPage < adicionarClientesLastPage"
                type="button"
                class="btn btn-outline-secondary btn-sm btn-block mt-2"
                :disabled="adicionarClientesLoading"
                @click="loadClientesElegiveis(false)"
              >
                <i v-if="adicionarClientesLoading" class="fas fa-circle-notch fa-spin mr-1"></i>
                Carregar mais
              </button>
            </div>
          </template>
          <template #footer>
            <span class="mr-auto small text-muted align-self-center">
              {{ adicionarClientesSelectedCount }} selecionado(s)
            </span>
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              :disabled="adicionarClientesSaving"
              data-dismiss="modal"
              @click="closeAdicionarClientesModal"
            >
              Cancelar
            </button>
            <Button
              variant="primary"
              size="sm"
              class="ml-2"
              :loading="adicionarClientesSaving"
              :disabled="!adicionarClientesSelectedCount"
              @click="confirmAdicionarClientes"
            >
              Adicionar à coluna
            </Button>
          </template>
        </Modal>

        <Modal modal-id="modalCarteiraKanbanFaseItem" :title="faseModalTitle" dialog-class="modal-dialog-centered">
          <template #body>
            <div class="carteira-kanban-vue__fase-modal-form">
              <div class="form-row">
                <div class="col-md-8">
                  <Input
                    v-model="faseForm.nome"
                    name="carteira_kanban_fase_nome"
                    id="carteira-kanban-fase-nome"
                    label="Nome da coluna <span class='text-danger'>*</span>"
                    placeholder="Nome"
                    required
                    :erro="faseNomeInvalido"
                    input-class="form-control-sm"
                    classe="mb-2 mb-md-2"
                  />
                </div>
                <div class="col-md-4">
                  <Input
                    v-model="faseOrdemStr"
                    name="carteira_kanban_fase_ordem"
                    id="carteira-kanban-fase-ordem"
                    label="Ordem"
                    type="number"
                    input-class="form-control-sm"
                    classe="mb-2 mb-md-2"
                  />
                </div>
              </div>
              <div class="form-group mb-0">
                <label class="small mb-1 d-block" for="carteira-kanban-fase-cor">Cor</label>
                <div class="d-flex align-items-stretch flex-wrap carteira-kanban-vue__fase-cor-inputs">
                  <input
                    id="carteira-kanban-fase-cor"
                    v-model="faseForm.cor"
                    type="color"
                    class="form-control border carteira-kanban-vue__fase-cor-swatch p-1"
                    aria-label="Escolher cor da coluna"
                  />
                  <input
                    id="carteira-kanban-fase-cor-hex"
                    v-model="faseForm.cor"
                    type="text"
                    class="form-control form-control-sm carteira-kanban-vue__fase-cor-hex"
                    maxlength="7"
                    placeholder="#2563eb"
                    autocapitalize="off"
                    autocomplete="off"
                    spellcheck="false"
                  />
                </div>
              </div>
              <p v-if="faseFormError" class="text-danger small mb-0 mt-2">{{ faseFormError }}</p>
            </div>
          </template>
          <template #footer>
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
            <Button variant="primary" size="sm" :loading="faseSaving" @click="saveFaseModal">Salvar</Button>
          </template>
        </Modal>

        <Modal
          modal-id="modalCarteiraKanbanFaseOrdem"
          title="Ordenar colunas"
          dialog-class="modal-dialog-centered"
        >
          <template #body>
            <p class="text-muted small mb-3 mb-md-3">
              Arraste as colunas para definir a ordem exibida no Kanban.
            </p>
            <p v-if="!faseOrdemPodeArrastar" class="text-muted small mb-0">
              Adicione mais colunas para reordenar.
            </p>
            <ul
              v-else
              class="carteira-kanban-vue__fase-ordem-list list-unstyled mb-0"
              @dragover="onFaseOrdemDragOver"
            >
              <li
                v-for="(item, index) in faseOrdemDraft"
                :key="item.id"
                class="carteira-kanban-vue__fase-ordem-item d-flex align-items-center"
                :class="{
                  'carteira-kanban-vue__fase-ordem-item--dragging': faseOrdemDragIndex === index,
                }"
                draggable="true"
                @dragstart="onFaseOrdemDragStart(index, $event)"
                @dragend="onFaseOrdemDragEnd"
                @dragover.prevent
                @drop="onFaseOrdemDrop(index, $event)"
              >
                <span class="carteira-kanban-vue__fase-ordem-handle text-muted" aria-hidden="true">
                  <i class="fas fa-grip-vertical"></i>
                </span>
                <span
                  class="carteira-kanban-vue__fase-ordem-swatch flex-shrink-0"
                  :style="{ backgroundColor: columnBg(item) }"
                  aria-hidden="true"
                ></span>
                <span
                  class="carteira-kanban-vue__fase-ordem-nome flex-grow-1 min-width-0 text-truncate"
                >
                  {{ item.nome }}
                </span>
              </li>
            </ul>
          </template>
          <template #footer>
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              :disabled="faseOrdemSaving"
              @click="closeFaseOrdemModal"
            >
              Cancelar
            </button>
            <Button
              variant="primary"
              size="sm"
              :loading="faseOrdemSaving"
              :disabled="!faseOrdemPodeArrastar"
              @click="saveFaseOrdemModal"
            >
              Salvar
            </Button>
          </template>
        </Modal>
      </div>

      <div v-if="bootstrapLoading" class="carteira-kanban-vue__loading" aria-live="polite" aria-busy="true">
        <div class="carteira-kanban-vue__loading-header">
          <div class="carteira-kanban-vue__loading-spinner" aria-hidden="true">
            <span></span><span></span><span></span>
          </div>
          <p class="carteira-kanban-vue__loading-title mb-0">Carregando sua carteira</p>
          <p class="carteira-kanban-vue__loading-subtitle mb-0">Montando colunas e clientes…</p>
        </div>
        <div class="carteira-kanban-vue__loading-filters" aria-hidden="true">
          <span class="carteira-kanban-vue__shimmer carteira-kanban-vue__shimmer--filter"></span>
          <span class="carteira-kanban-vue__shimmer carteira-kanban-vue__shimmer--filter"></span>
          <span class="carteira-kanban-vue__shimmer carteira-kanban-vue__shimmer--btn"></span>
        </div>
        <div class="carteira-kanban-vue__loading-board" aria-hidden="true">
          <div
            v-for="n in skeletonColumnCount"
            :key="'sk-col-' + n"
            class="carteira-kanban-vue__sk-column"
          >
            <div class="carteira-kanban-vue__sk-head carteira-kanban-vue__shimmer"></div>
            <div class="carteira-kanban-vue__sk-body">
              <div
                v-for="c in skeletonCardsPerColumn"
                :key="'sk-card-' + n + '-' + c"
                class="carteira-kanban-vue__sk-card"
              >
                <div class="carteira-kanban-vue__sk-card-main">
                  <span class="carteira-kanban-vue__shimmer carteira-kanban-vue__shimmer--line-lg"></span>
                  <span class="carteira-kanban-vue__shimmer carteira-kanban-vue__shimmer--line-sm"></span>
                  <span class="carteira-kanban-vue__shimmer carteira-kanban-vue__shimmer--line-xs"></span>
                  <div class="carteira-kanban-vue__sk-tags">
                    <span class="carteira-kanban-vue__shimmer carteira-kanban-vue__shimmer--tag"></span>
                    <span class="carteira-kanban-vue__shimmer carteira-kanban-vue__shimmer--tag"></span>
                  </div>
                </div>
                <span class="carteira-kanban-vue__sk-rail carteira-kanban-vue__shimmer"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="bootstrapError" class="alert alert-danger mb-3" role="alert">
        {{ bootstrapError }}
      </div>
      <template v-else>
        <div class="carteira-kanban-vue__workspace">
          <div class="kanban-filters carteira-kanban-vue__filters">
            <div class="kanban-filters__wrapper">
              <div class="kanban-filters__primary">
                <div class="kanban-filter kanban-filter--md">
                  <div class="form-group mb-0">
                    <label class="small mb-1" for="carteira-kanban-busca-nome">Cliente</label>
                    <VuetifyWrapper>
                      <v-text-field
                        id="carteira-kanban-busca-nome"
                        v-model="kanbanBuscaNome"
                        name="nome"
                        class="multi-select carteira-kanban-vue__filter-nome"
                        placeholder="Nome, fantasia ou razão social"
                        filled
                        hide-details
                        clearable
                        autocomplete="off"
                        @keyup.enter="aplicarFiltros"
                      />
                    </VuetifyWrapper>
                  </div>
                </div>
                <div class="kanban-filter kanban-filter--md">
                  <Autocomplete
                    v-model="grupoSelection"
                    name="b2b_grupo_ids"
                    label="Grupo"
                    placeholder="Todos os grupos"
                    :items="gruposAutocompleteItems"
                    :multiple="true"
                    clearable
                    classe="mb-0"
                  />
                </div>
                <div v-if="tagsFiltro.length" class="kanban-filter kanban-filter--md">
                  <Autocomplete
                    v-model="tagSelection"
                    name="tags"
                    label="Tags"
                    placeholder="Todas as tags"
                    :items="tagsAutocompleteItems"
                    :multiple="true"
                    clearable
                    classe="mb-0"
                  />
                </div>
                <div class="kanban-filter kanban-filters__actions filter-buttons">
                  <button
                    v-if="temFiltrosExtras"
                    type="button"
                    class="btn btn-outline-light btn-sm kanban-filters__toggle collapsed"
                    data-toggle="collapse"
                    data-target="#carteira-kanban-extra-filtros"
                    aria-expanded="false"
                    aria-controls="carteira-kanban-extra-filtros"
                  >
                    <i class="fas fa-sliders-h mr-1"></i>
                    <span>Mais filtros</span>
                    <i class="fas fa-chevron-down ml-1 kanban-filters__toggle-caret"></i>
                  </button>
                  <button type="button" class="btn btn-success btn-sm mr-1" title="Aplicar filtros" @click="aplicarFiltros">
                    <i class="fas fa-search"></i>
                  </button>
                  <button type="button" class="btn btn-cancel btn-sm" title="Limpar filtros" @click="limparFiltros">
                    <i class="fas fa-times"></i>
                  </button>
                  <div
                    v-if="podeGerenciarFasesUi || podeMoverCardsKanban"
                    class="btn-group dropleft"
                  >
                    <button
                      type="button"
                      class="btn btn-depth btn-outline-primary btn-sm dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      title="Opções"
                    >
                      <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                    </button>
                    <div class="dropdown-menu">
                      <button
                        v-if="podeMoverCardsKanban"
                        type="button"
                        class="dropdown-item btn-card-status"
                        @click="toggleSemColunaColumn"
                      >
                        <i
                          class="mr-2"
                          :class="semColunaColumnVisible ? 'fas fa-eye-slash' : 'fas fa-inbox'"
                          aria-hidden="true"
                        ></i>
                        {{ semColunaColumnVisible ? "Ocultar sem coluna" : "Ver sem coluna" }}
                        <span v-if="semColunaColumn.total > 0"> ({{ semColunaColumn.total }})</span>
                      </button>
                      <button
                        v-if="podeGerenciarFasesUi"
                        type="button"
                        class="dropdown-item btn-card-status"
                        @click="openFaseModal(null)"
                      >
                        <i class="fas fa-plus mr-2" aria-hidden="true"></i>Nova coluna
                      </button>
                      <button
                        v-if="podeGerenciarFasesUi"
                        type="button"
                        class="dropdown-item btn-card-status"
                        @click="openFaseOrdemModal"
                      >
                        <i class="fas fa-sort mr-2" aria-hidden="true"></i>Ordenar colunas
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="temFiltrosExtras"
                id="carteira-kanban-extra-filtros"
                class="kanban-filters__secondary collapse"
              >
                <div class="kanban-filters__secondary-inner">
                  <div
                    v-if="podeVisualizarKanbanOutrosUsuarios"
                    class="kanban-filter kanban-filter--md"
                    :class="{ 'carteira-kanban-vue__filter-kanban-donos': carteiraKanbanColunasCompartilhadas }"
                  >
                    <Autocomplete
                      v-if="carteiraKanbanColunasCompartilhadas"
                      :value="kanbanDonoFilterSelection"
                      name="carteira_kanban_usuarios"
                      label="Filtrar clientes por dono"
                      placeholder="Todos os donos"
                      :items="usuariosKanbanAutocompleteItems"
                      :multiple="true"
                      clearable
                      classe="mb-0"
                      @input="onKanbanDonoFilterSelect"
                    />
                    <Autocomplete
                      v-else
                      :value="kanbanOwnerSelection"
                      name="carteira_kanban_usuario"
                      label="Kanban do usuário"
                      placeholder="Meu Kanban"
                      :items="usuariosKanbanAutocompleteItems"
                      :multiple="false"
                      clearable
                      classe="mb-0"
                      @input="onKanbanOwnerSelect"
                    />
                  </div>
                  <div class="kanban-filter kanban-filter--md">
                    <Autocomplete
                      :value="tarefaFilterSelection"
                      name="tarefa_status"
                      label="Tarefas"
                      placeholder="Todas"
                      :items="tarefaFiltros"
                      :multiple="false"
                      clearable
                      classe="mb-0"
                      @input="onTarefaFilterSelect"
                    />
                  </div>
                </div>
              </div>
              <p v-if="kanbanSomenteLeitura" class="text-muted small mb-0 mt-2">
                Visualização somente leitura — sem permissão para alterar este Kanban.
              </p>
            </div>
          </div>

          <div class="carteira-kanban-vue__board-wrap">
            <div
              v-show="boardScrollNavVisible && boardCanScrollLeft"
              class="carteira-kanban-vue__board-scroll-fade carteira-kanban-vue__board-scroll-fade--left"
              aria-hidden="true"
            ></div>
            <button
              v-show="boardScrollNavVisible && boardCanScrollLeft"
              type="button"
              class="carteira-kanban-vue__board-scroll-btn carteira-kanban-vue__board-scroll-btn--left"
              aria-label="Ver colunas anteriores"
              title="Ver colunas anteriores"
              @click="scrollBoardHorizontal(-1)"
            >
              <i class="fas fa-chevron-left" aria-hidden="true"></i>
            </button>
            <div
              v-show="boardScrollNavVisible && boardCanScrollRight"
              class="carteira-kanban-vue__board-scroll-fade carteira-kanban-vue__board-scroll-fade--right"
              aria-hidden="true"
            ></div>
            <button
              v-show="boardScrollNavVisible && boardCanScrollRight"
              type="button"
              class="carteira-kanban-vue__board-scroll-btn carteira-kanban-vue__board-scroll-btn--right"
              aria-label="Ver próximas colunas"
              title="Ver próximas colunas"
              @click="scrollBoardHorizontal(1)"
            >
              <i class="fas fa-chevron-right" aria-hidden="true"></i>
            </button>
            <div
              ref="boardScroll"
              class="carteira-kanban-vue__board"
              :class="{ 'carteira-kanban-vue__board--refreshing': boardRefreshing }"
              @scroll.passive="onBoardScroll"
            >
              <div v-if="boardRefreshing" class="carteira-kanban-vue__board-overlay" aria-live="polite" aria-busy="true">
                <div class="carteira-kanban-vue__board-overlay-inner">
                  <div class="carteira-kanban-vue__loading-spinner carteira-kanban-vue__loading-spinner--sm" aria-hidden="true">
                    <span></span><span></span><span></span>
                  </div>
                  <span>Atualizando kanban…</span>
                </div>
              </div>
              <div
                v-for="col in boardColumns"
                :key="columnBoardKey(col)"
                class="carteira-kanban-vue__column"
                :class="{ 'carteira-kanban-vue__column--sem-coluna': isSemColunaColumn(col) }"
                @dragover.prevent
                @drop="onDrop(col, $event)"
              >
                <header
                  class="carteira-kanban-vue__column-head"
                  :class="'carteira-kanban-vue__column-head--' + columnCountContrast(col)"
                  :style="{ backgroundColor: columnBg(col), color: columnFg(col) }"
                >
                  <div class="carteira-kanban-vue__column-head-inner d-flex align-items-center">
                    <div class="carteira-kanban-vue__column-title-wrap flex-grow-1 min-width-0">
                      <h2
                        class="carteira-kanban-vue__column-title mb-0"
                        :title="col.nome"
                      >{{ col.nome }}</h2>
                      <p
                        v-for="campoTotal in col.totaisCampos"
                        :key="'total-' + col.id + '-' + campoTotal.campo_id"
                        class="carteira-kanban-vue__column-campo-total mb-0"
                        :class="'carteira-kanban-vue__column-campo-total--' + columnCountContrast(col)"
                      >
                        {{ campoTotal.nome }}: {{ formatCurrency(campoTotal.total) }}
                      </p>
                      <p
                        v-if="isSemColunaColumn(col)"
                        class="carteira-kanban-vue__column-subtitle mb-0"
                      >
                        Arraste para uma coluna
                      </p>
                    </div>
                    <div class="carteira-kanban-vue__column-actions d-flex align-items-center flex-shrink-0">
                      <span
                        class="carteira-kanban-vue__column-count"
                        :class="'carteira-kanban-vue__column-count--' + columnCountContrast(col)"
                      >{{ col.total }}</span>
                      <button
                        v-if="isSemColunaColumn(col)"
                        type="button"
                        class="btn btn-link btn-sm p-0 carteira-kanban-vue__col-close"
                        title="Fechar"
                        :style="{ color: columnFg(col) }"
                        @click.stop="closeSemColunaColumn"
                      >
                        <i class="fas fa-times" aria-hidden="true"></i>
                      </button>
                      <button
                        v-else-if="podeAdicionarClientesKanban"
                        type="button"
                        class="btn btn-link btn-sm p-0 carteira-kanban-vue__col-add"
                        title="Adicionar clientes"
                        :style="{ color: columnFg(col) }"
                        @click="openAdicionarClientesModal(col)"
                      >
                        <i class="fas fa-user-plus"></i>
                      </button>
                      <div v-if="podeGerenciarFasesUi && !isSemColunaColumn(col)" class="dropdown">
                        <button
                          type="button"
                          class="btn btn-link btn-sm p-0 carteira-kanban-vue__col-cog"
                          style="line-height: 1"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :style="{ color: columnFg(col) }"
                        >
                          <i class="fas fa-cog"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right shadow-sm">
                          <button type="button" class="dropdown-item" @click="openFaseModal(col)">
                            <i class="fas fa-edit mr-2"></i>Editar coluna
                          </button>
                          <button type="button" class="dropdown-item text-danger" @click="openDeleteFaseModal(col)">
                            <i class="fas fa-trash mr-2"></i>Excluir
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>

                <div class="carteira-kanban-vue__column-body">
                  <div
                    v-if="col.loading && !col.items.length"
                    class="carteira-kanban-vue__column-loading"
                    aria-live="polite"
                    aria-busy="true"
                  >
                    <div class="carteira-kanban-vue__column-loading-inner">
                      <div class="carteira-kanban-vue__loading-spinner carteira-kanban-vue__loading-spinner--sm" aria-hidden="true">
                        <span></span><span></span><span></span>
                      </div>
                      <span>Carregando clientes…</span>
                    </div>
                  </div>
                  <div
                    class="carteira-kanban-vue__column-scroll-pane"
                    :class="{ 'carteira-kanban-vue__cards--dimmed': col.loading && col.items.length }"
                  >
                  <div class="carteira-kanban-vue__cards">
                    <article
                      v-for="card in col.items"
                      :key="card.id"
                      class="carteira-kanban-vue__card card mb-2"
                      :class="{ 'carteira-kanban-vue__card--drag': podeMoverCardsKanban }"
                      :style="cardColumnStripeStyle(col)"
                      :draggable="podeMoverCardsKanban"
                      @dragstart="onDragStart(card, $event)"
                    >
                      <div class="carteira-kanban-vue__card-inner">
                        <div class="carteira-kanban-vue__card-main">
                          <div class="carteira-kanban-vue__card-title">{{ displayNome(card) }}</div>
                          <div v-if="card.grupo_nome" class="carteira-kanban-vue__meta">{{ card.grupo_nome }}</div>
                          <div
                            v-if="podeVisualizarKanbanOutrosUsuarios && card.dono_nome"
                            class="carteira-kanban-vue__meta"
                          >
                            Dono: {{ card.dono_nome }}
                          </div>
                          <div
                            v-if="carteiraKanbanUltimaReuniao && card.ultima_reuniao"
                            class="carteira-kanban-vue__meta"
                            :class="ultimaReuniaoIndicadorClass(card.ultima_reuniao)"
                            :title="ultimaReuniaoIndicadorTitle(card.ultima_reuniao)"
                          >
                            Última reunião: {{ card.ultima_reuniao.data_label }}
                            <template v-if="card.ultima_reuniao.titulo"> — {{ card.ultima_reuniao.titulo }}</template>
                          </div>
                          <div
                            v-for="campo in (card.campos_kanban || [])"
                            :key="'campo-' + card.id + '-' + campo.id"
                            class="carteira-kanban-vue__card-campo-valor"
                            :style="cardCampoValorStyle(campo)"
                          >
                            {{ campo.nome }}: {{ campo.valor_formatado }}
                          </div>
                          <div v-if="card.tags && card.tags.length" class="tags-kanban carteira-kanban-vue__tags mt-2">
                            <span
                              v-for="tag in card.tags"
                              :key="tag.id"
                              class="badge badge-tag-kanban mr-1 mb-1"
                              :style="tagBadgeStyle(tag)"
                            >{{ tag.nome }}</span>
                          </div>
                        </div>
                        <div class="carteira-kanban-vue__card-rail" @mousedown.stop>
                          <button
                            type="button"
                            class="carteira-kanban-vue__card-rail-btn carteira-kanban-vue__card-rail-btn--oportunidade"
                            :title="oportunidadeRailTitle(card)"
                            @click.stop="onCardOportunidadeClick(card)"
                          >
                            <i class="fas fa-handshake" aria-hidden="true"></i>
                            <span
                              v-if="mensagensNaoLidasTotal(card) > 0"
                              class="carteira-kanban-vue__card-badge"
                              :title="mensagensNaoLidasTotal(card) + ' mensagem(ns) não lida(s)'"
                            >{{ mensagensNaoLidasBadge(mensagensNaoLidasTotal(card)) }}</span>
                          </button>
                          <button
                            type="button"
                            class="carteira-kanban-vue__card-rail-btn carteira-kanban-vue__card-rail-btn--cliente"
                            title="Abrir cliente"
                            @click.stop="onCardClienteClick(card)"
                          >
                            <i class="fas fa-id-card" aria-hidden="true"></i>
                          </button>
                          <button
                            type="button"
                            class="carteira-kanban-vue__card-rail-btn carteira-kanban-vue__card-rail-btn--tarefa"
                            :title="tarefasIndicadorTitle(card)"
                            @click.stop="onCardTarefasClick(card)"
                          >
                            <i class="fas fa-tasks" aria-hidden="true"></i>
                            <span
                              v-if="tarefasIndicadorTotal(card) > 0"
                              class="carteira-kanban-vue__card-badge"
                              :class="tarefasIndicadorBadgeClass(card)"
                            >{{ mensagensNaoLidasBadge(tarefasIndicadorTotal(card)) }}</span>
                          </button>
                        </div>
                      </div>
                    </article>
                  </div>
                  <button
                    v-if="col.hasMore"
                    type="button"
                    class="btn btn-outline-secondary btn-sm btn-block carteira-kanban-vue__load-more"
                    :disabled="col.loading"
                    @click="loadMore(col)"
                  >
                    <i v-if="col.loading" class="fas fa-circle-notch fa-spin mr-1" aria-hidden="true"></i>
                    {{ col.loading ? "Carregando…" : "Carregar mais" }}
                  </button>
                  </div>
                </div>
              </div>

              <div
                v-if="podeGerenciarFasesUi"
                class="carteira-kanban-vue__add-column-slot"
              >
                <button
                  type="button"
                  class="carteira-kanban-vue__add-column d-flex flex-column align-items-center justify-content-center"
                  aria-label="Nova coluna"
                  title="Nova coluna"
                  @click="openFaseModal(null)"
                >
                  <i class="fas fa-plus carteira-kanban-vue__add-column-icon" aria-hidden="true"></i>
                  <span class="carteira-kanban-vue__add-column-label">Nova coluna</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </vuetify-wrapper>
</template>

<script>
import axios from "axios";
import VuetifyWrapper from "../VuetifyWrapper.vue";
import Modal from "../ui/Modal.vue";
import Button from "../ui/Button.vue";
import Input from "../ui/Input.vue";
import Autocomplete from "../ui/Autocomplete.vue";

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Requested-With": "XMLHttpRequest",
};

/** Evita seguir redirect 302 do Laravel com PUT (gera 405 no index). */
const axiosSaveOptions = {
  headers: jsonHeaders,
  maxRedirects: 0,
};

function csrf() {
  const m = document.querySelector('meta[name="csrf-token"]');
  return m ? m.getAttribute("content") : "";
}

function normalizeApiBase(base) {
  return String(base || "").replace(/\/+$/, "");
}

/** Mesmo path da rota nomeada `painel.carteira.kanban.bootstrap`. */
const KANBAN_BOOTSTRAP_URL = "/painel/carteira/kanban/bootstrap";

const DEFAULT_COR = "#6c757d";

/** Id virtual da coluna temporária de clientes sem fase no kanban. */
const SEM_COLUNA_KANBAN_ID = "sem_coluna";

const SEM_COLUNA_COR = "#8b9299";

/** Largura de coluna (292px) + gap do board (1rem), vezes colunas por clique. */
const BOARD_SCROLL_STEP = 308 * 3;

/** Colunas carregadas por request em colunas/clientes. */
const KANBAN_COLUNAS_BATCH_SIZE = 4;

function createSemColunaColumnState() {
  return {
    id: SEM_COLUNA_KANBAN_ID,
    isSemColuna: true,
    nome: "Sem coluna",
    cor: SEM_COLUNA_COR,
    ordem: -1,
    items: [],
    page: 1,
    lastPage: 1,
    loading: false,
    hasMore: false,
    total: 0,
    totaisCampos: [],
  };
}

/** Cores vivas para novas colunas (evita repetir as já usadas no board quando possível). */
const FASE_CORES_PALETA = [
  "#2563eb",
  "#059669",
  "#d97706",
  "#7c3aed",
  "#db2777",
  "#0891b2",
  "#4f46e5",
  "#16a34a",
  "#ea580c",
  "#be123c",
  "#0d9488",
  "#9333ea",
  "#ca8a04",
  "#dc2626",
  "#0284c7",
  "#65a30d",
  "#c026d3",
  "#e11d48",
  "#0369a1",
  "#15803d",
];

function randomFaseCor(usedCores = []) {
  const used = new Set(
    (usedCores || [])
      .map((c) => normalizeHexCor(c).toLowerCase())
      .filter((c) => c !== DEFAULT_COR.toLowerCase())
  );
  const pool = FASE_CORES_PALETA.filter((c) => !used.has(c.toLowerCase()));
  const pickFrom = pool.length ? pool : FASE_CORES_PALETA;
  return pickFrom[Math.floor(Math.random() * pickFrom.length)];
}

function bs$(selector) {
  const jq = typeof window !== "undefined" ? window.jQuery || window.$ : null;
  if (!jq) {
    return { modal: () => {} };
  }
  return jq(selector);
}

function normalizeHexCor(v) {
  if (!v || typeof v !== "string") return DEFAULT_COR;
  const s = v.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(s)) return s;
  return DEFAULT_COR;
}

function fieldLabel(key) {
  const map = { nome: "Nome", cor: "Cor", ordem: "Ordem" };
  return map[key] || String(key).replace(/_/g, " ");
}

function textoSobreCorDeFundo(hex) {
  const h = normalizeHexCor(hex).replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 186 ? "#212529" : "#ffffff";
}

function formatCurrencyBr(value) {
  const n = Number(value) || 0;
  if (typeof numeral !== "undefined") {
    return numeral(n).format("$ 0,0.00");
  }
  return n.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export default {
  name: "CarteiraKanbanApp",
  components: {
    VuetifyWrapper,
    Modal,
    Button,
    Input,
    Autocomplete,
  },
  data() {
    return {
      bootstrapLoading: true,
      boardRefreshing: false,
      skeletonColumnCount: 4,
      skeletonCardsPerColumn: 3,
      bootstrapLoaded: false,
      bootstrapError: "",
      gruposFiltro: [],
      tagsFiltro: [],
      tarefaFiltros: [
        { id: "", value: "Todas" },
        { id: "em-dia", value: "Com tarefa em dia" },
        { id: "para-hoje", value: "Com tarefa para hoje" },
        { id: "atrasada", value: "Com tarefa atrasada" },
        { id: "sem-tarefa", value: "Sem tarefa" },
      ],
      kanbanTarefaStatus: "",
      kanbanBuscaNome: "",
      grupoSelection: [],
      tagSelection: [],
      routes: {},
      podeGerenciarCadastro: false,
      podeGerenciarFasesKanban: false,
      podeMoverCardsKanban: false,
      podeAdicionarClientesKanban: false,
      adicionarClientesCol: null,
      adicionarClientesFaseId: null,
      adicionarClientesBusca: "",
      adicionarClientesLista: [],
      adicionarClientesSelected: {},
      adicionarClientesSelectedRows: {},
      adicionarClientesPage: 1,
      adicionarClientesLastPage: 1,
      adicionarClientesLoading: false,
      adicionarClientesLoadSeq: 0,
      adicionarClientesSaving: false,
      adicionarClientesErro: "",
      carteiraKanbanColunasCompartilhadas: false,
      carteiraKanbanUltimaReuniao: false,
      camposKanbanTotais: [],
      carteiraKanbanOwnerUserId: null,
      carteiraKanbanAuthUserId: null,
      podeVisualizarKanbanOutrosUsuarios: false,
      usuariosKanbanOpcoes: [],
      kanbanOwnerSelection: null,
      kanbanDonoFilterSelection: [],
      fasesLista: [],
      columnsState: [],
      semColunaColumnVisible: false,
      semColunaColumn: createSemColunaColumnState(),
      draggingCliente: null,
      faseDeleteTarget: null,
      faseDeleteMigrarParaId: null,
      faseDeleteLoading: false,
      oportunidadePickerCard: null,
      oportunidadeCriando: false,
      oportunidadePickerLoading: false,
      oportunidadePickerErro: "",
      oportunidadePickerAba: "abertas",
      oportunidadeEncerradas: [],
      oportunidadeEncerradasTotal: 0,
      oportunidadeEncerradasHasMore: false,
      oportunidadeEncerradasLoading: false,
      oportunidadeEncerradasLoadingMore: false,
      oportunidadeEncerradasErro: "",
      oportunidadeEncerradasLoadSeq: 0,
      podeCriarOportunidade: false,
      tarefaPickerCard: null,
      tarefaPickerLoadSeq: 0,
      tarefaPickerLoading: false,
      tarefaConcluindoId: null,
      tarefaPickerSaving: false,
      tarefaPickerErro: "",
      tarefaPickerTarefas: [],
      tarefaPickerPodeCriar: false,
      tarefaPickerShowForm: false,
      tarefaPickerVerConcluidas: false,
      tarefaPickerAba: "tarefas",
      tarefaNotas: [],
      tarefaNotasTotal: 0,
      tarefaNotasHasMore: false,
      tarefaNotasLoading: false,
      tarefaNotasLoadingMore: false,
      tarefaNotasErro: "",
      tarefaNotasLoadSeq: 0,
      tarefaPickerFormMeta: {
        tipos: [],
        users: [],
        contatos: [],
        templates_por_cliente: {},
        default_cliente_id: null,
      },
      tarefaPickerForm: {
        cliente_id: "",
        titulo: "",
        tipo: "",
        user_id: "",
        data: "",
        hora: "",
        descricao: "",
        template_id: "",
      },
      faseSaving: false,
      faseEditingId: null,
      faseForm: {
        nome: "",
        cor: DEFAULT_COR,
        ordem: null,
      },
      faseFormError: "",
      faseErrorModalTitle: "Atenção",
      faseErrorModalMessage: "",
      faseErrorModalItems: [],
      faseOrdemDraft: [],
      faseOrdemSaving: false,
      faseOrdemDragIndex: null,
      boardCanScrollLeft: false,
      boardCanScrollRight: false,
    };
  },
  watch: {
    bootstrapLoading(val) {
      if (!val) {
        this.$nextTick(() => {
          this.setupBoardScrollObservers();
          this.updateBoardScrollHints();
        });
      }
    },
    "boardColumns.length"() {
      this.$nextTick(() => this.updateBoardScrollHints());
    },
    semColunaColumnVisible() {
      this.$nextTick(() => this.updateBoardScrollHints());
    },
    boardRefreshing(val) {
      if (!val) {
        this.$nextTick(() => this.updateBoardScrollHints());
      }
    },
  },
  computed: {
    kanbanRoutes() {
      return (this.routes && this.routes.kanban) || {};
    },
    podeGerenciarFasesUi() {
      const api = this.routes && this.routes.fasesApi;
      return (
        this.podeGerenciarFasesKanban &&
        api &&
        api.base &&
        api.index &&
        api.store
      );
    },
    usuariosKanbanAutocompleteItems() {
      return (this.usuariosKanbanOpcoes || []).map((u) => ({
        id: u.id,
        value: u.value != null ? u.value : u.nome,
      }));
    },
    kanbanSomenteLeitura() {
      return !this.podeMoverCardsKanban;
    },
    boardColumns() {
      if (!this.semColunaColumnVisible) {
        return this.columnsState;
      }
      return [this.semColunaColumn, ...this.columnsState];
    },
    boardScrollNavVisible() {
      return !this.bootstrapLoading && !this.boardRefreshing;
    },
    faseModalTitle() {
      return this.faseEditingId ? "Editar coluna do Kanban" : "Nova coluna do Kanban";
    },
    faseOrdemPodeArrastar() {
      return this.faseOrdemDraft.length >= 2;
    },
    faseNomeInvalido() {
      return this.faseFormError !== "" && (this.faseForm.nome || "").trim() === "";
    },
    adicionarClientesModalTitle() {
      const col = this.adicionarClientesCol;
      return col && col.nome
        ? `Adicionar clientes — ${col.nome}`
        : "Adicionar clientes à coluna";
    },
    adicionarClientesSelectedCount() {
      return Object.keys(this.adicionarClientesSelected).filter(
        (k) => this.adicionarClientesSelected[k],
      ).length;
    },
    adicionarClientesListaExibida() {
      const lista = this.adicionarClientesLista || [];
      const idsNaLista = new Set(lista.map((r) => String(r.id)));
      const fixados = Object.keys(this.adicionarClientesSelectedRows)
        .filter((k) => this.adicionarClientesSelected[k] && !idsNaLista.has(k))
        .map((k) => this.adicionarClientesSelectedRows[k])
        .filter(Boolean);
      return fixados.concat(lista);
    },
    faseOrdemStr: {
      get() {
        const o = this.faseForm.ordem;
        if (o === null || o === undefined || o === "") return "";
        return String(o);
      },
      set(v) {
        if (v === "" || v === null || v === undefined) {
          this.faseForm.ordem = null;
          return;
        }
        const n = Number(v);
        this.faseForm.ordem = Number.isNaN(n) ? null : n;
      },
    },
    gruposAutocompleteItems() {
      return (this.gruposFiltro || []).map((g) => ({
        id: g.id,
        value: g.value ?? g.nome ?? String(g.id ?? ""),
      }));
    },
    tagsAutocompleteItems() {
      const itens = [{ id: "sem_tag", value: "Sem tags" }];
      (this.tagsFiltro || []).forEach((tag) => {
        itens.push({
          id: tag.id,
          value: tag.nome ?? String(tag.id ?? ""),
        });
      });
      return itens;
    },
    tarefaFilterSelection() {
      const id = this.kanbanTarefaStatus ?? "";
      return (
        this.tarefaFiltros.find((o) => String(o.id) === String(id)) ||
        this.tarefaFiltros[0] ||
        null
      );
    },
    temFiltrosExtras() {
      return true;
    },
    faseDeleteDestinoOpcoes() {
      if (!this.faseDeleteTarget) {
        return [];
      }
      const id = Number(this.faseDeleteTarget.id);
      return this.columnsState.filter((c) => Number(c.id) !== id);
    },
    faseDeletePodeConfirmar() {
      if (!this.faseDeleteTarget) {
        return false;
      }
      if (this.faseDeleteTarget.total > 0) {
        if (!this.faseDeleteDestinoOpcoes.length) {
          return false;
        }
        return !!this.faseDeleteMigrarParaId;
      }
      return true;
    },
    oportunidadePickerList() {
      if (!this.oportunidadePickerCard) {
        return [];
      }
      return this.sortOportunidadesLista(this.oportunidadesAbertas(this.oportunidadePickerCard));
    },
    oportunidadePickerListaAtual() {
      if (this.oportunidadePickerAba === "encerradas") {
        return this.oportunidadeEncerradas;
      }
      return this.oportunidadePickerList;
    },
    oportunidadePickerHeadCount() {
      if (this.oportunidadePickerAba === "encerradas") {
        return this.oportunidadeEncerradasTotal || 0;
      }
      return this.oportunidadePickerList.length;
    },
    oportunidadePickerHeadValor() {
      const lista = this.oportunidadePickerListaAtual;
      if (!lista.some((op) => op.valor != null)) {
        return null;
      }
      return lista.reduce((soma, op) => soma + (Number(op.valor) || 0), 0);
    },
    oportunidadePickerTabLoading() {
      if (this.oportunidadePickerAba === "encerradas") {
        return this.oportunidadeEncerradasLoading && !this.oportunidadeEncerradas.length;
      }
      return this.oportunidadePickerLoading;
    },
    oportunidadePickerTabErro() {
      if (this.oportunidadePickerAba === "encerradas") {
        return this.oportunidadeEncerradasErro;
      }
      return this.oportunidadePickerErro;
    },
    oportunidadePickerEmptyText() {
      if (this.oportunidadePickerAba === "encerradas") {
        return "Nenhuma oportunidade encerrada.";
      }
      return "Nenhuma oportunidade em aberto.";
    },
    oportunidadePickerModalTitle() {
      return "Oportunidades";
    },
    tarefaPickerAbertas() {
      return (this.tarefaPickerTarefas || []).filter((t) => !t.concluida);
    },
    tarefaPickerConcluidas() {
      return (this.tarefaPickerTarefas || []).filter((t) => t.concluida);
    },
    tarefaPickerListaExibicao() {
      const abertas = [...this.tarefaPickerAbertas].sort((a, b) => {
        const da = `${a.data} ${a.hora}`;
        const db = `${b.data} ${b.hora}`;
        return da.localeCompare(db);
      });
      if (!this.tarefaPickerVerConcluidas) {
        return abertas;
      }
      const concluidas = [...this.tarefaPickerConcluidas].sort((a, b) => {
        const da = `${a.data} ${a.hora}`;
        const db = `${b.data} ${b.hora}`;
        return db.localeCompare(da);
      });
      return abertas.concat(concluidas);
    },
    tarefaPickerModalTitle() {
      if (this.tarefaPickerAba === "notas") {
        return "Notas da conta";
      }
      const n = this.tarefaPickerAbertas.length;
      if (!n) {
        return "Tarefas do cliente";
      }
      return `Tarefas do cliente (${n} abertas)`;
    },
    tarefaPickerFormWhatsapp() {
      return this.tarefaPickerForm.tipo === "whatsapp";
    },
    tarefaPickerContatos() {
      return Array.isArray(this.tarefaPickerFormMeta.contatos)
        ? this.tarefaPickerFormMeta.contatos
        : [];
    },
    tarefaPickerMostraSeletorContato() {
      return this.tarefaPickerContatos.length > 1;
    },
    tarefaPickerTemplatesWhatsapp() {
      const map = this.tarefaPickerFormMeta.templates_por_cliente || {};
      const cid = Number(this.tarefaPickerForm.cliente_id);
      const key = Number.isFinite(cid) && cid > 0 ? cid : this.tarefaPickerFormMeta.default_cliente_id;
      const list = map[key] || map[String(key)] || [];

      return Array.isArray(list) ? list : [];
    },
  },
  mounted() {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrf();
    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    this._onCarteiraKanbanAtualizarMessage = (event) => {
      this.processarAtualizacaoCarteiraKanbanCliente(
        event && event.data,
        event && event.source,
      );
    };
    window.addEventListener("message", this._onCarteiraKanbanAtualizarMessage);
    this._onCarteiraKanbanStorageRefresh = (event) => {
      if (!event || event.key !== "eloca:carteira-kanban-refresh" || !event.newValue) {
        return;
      }
      try {
        const data = JSON.parse(event.newValue);
        this.processarAtualizacaoCarteiraKanbanCliente(data, null);
      } catch (_e) {
        /* ignore */
      }
    };
    window.addEventListener("storage", this._onCarteiraKanbanStorageRefresh);
    try {
      const raw = localStorage.getItem("eloca:carteira-kanban-refresh");
      if (raw) {
        const data = JSON.parse(raw);
        this.processarAtualizacaoCarteiraKanbanCliente(data, null);
      }
    } catch (_e) {
      /* ignore */
    }
    this._onCarteiraKanbanNovaMensagem = (e) => {
      const id = e && e.detail && e.detail.oportunidadeId;
      if (id) {
        this.onWsNovaMensagem(id);
      }
    };
    this._onCarteiraKanbanLeituraOportunidade = (e) => {
      const id = e && e.detail && e.detail.oportunidadeId;
      if (id) {
        this.onWsLeituraOportunidade(id);
      }
    };
    this._onCarteiraKanbanNovoEmail = (e) => {
      const id = e && e.detail && e.detail.oportunidadeId;
      if (id) {
        this.onWsNovaMensagem(id);
      }
    };
    this._onCarteiraKanbanLidoEmail = (e) => {
      const detail = e && e.detail;
      if (!detail || !detail.oportunidadeId) {
        return;
      }
      if (Number(detail.naoLidos) > 0) {
        return;
      }
      this.onWsLeituraOportunidade(detail.oportunidadeId);
    };
    this._onCarteiraKanbanClienteAtualizado = (e) => {
      const detail = e && e.detail;
      if (detail && detail.clientePaiId) {
        this.onWsClienteCarteiraAtualizado(detail);
      }
    };
    this._onCarteiraKanbanDonosAtualizada = (e) => {
      this.onWsCarteiraDonosAtualizada(e && e.detail);
    };
    window.addEventListener("eloca:carteira-kanban-nova-mensagem", this._onCarteiraKanbanNovaMensagem);
    window.addEventListener("eloca:carteira-kanban-leitura-oportunidade", this._onCarteiraKanbanLeituraOportunidade);
    window.addEventListener("eloca:carteira-kanban-novo-email", this._onCarteiraKanbanNovoEmail);
    window.addEventListener("eloca:carteira-kanban-lido-email", this._onCarteiraKanbanLidoEmail);
    window.addEventListener("eloca:carteira-kanban-cliente-atualizado", this._onCarteiraKanbanClienteAtualizado);
    window.addEventListener("eloca:carteira-kanban-donos-atualizada", this._onCarteiraKanbanDonosAtualizada);
    const jq = window.jQuery;
    if (jq) {
      jq("#modalCarteiraKanbanAdicionarClientes")
        .off("hidden.bs.modal.carteiraKanbanAdicionar")
        .on("hidden.bs.modal.carteiraKanbanAdicionar", () => {
          const $modal = jq("#modalCarteiraKanbanAdicionarClientes");
          window.setTimeout(() => {
            if ($modal.hasClass("show")) {
              return;
            }
            this.resetAdicionarClientesModal();
          }, 150);
        });
      jq("#modalCarteiraKanbanTarefas")
        .off("hidden.bs.modal.carteiraKanbanTarefas")
        .on("hidden.bs.modal.carteiraKanbanTarefas", () => {
          const $modal = jq("#modalCarteiraKanbanTarefas");
          window.setTimeout(() => {
            if ($modal.hasClass("show")) {
              return;
            }
            this.resetTarefaPickerModal();
          }, 150);
        });
    }
    this.fetchBootstrap();
  },
  beforeDestroy() {
    this.teardownBoardScrollObservers();
    if (this._onCarteiraKanbanAtualizarMessage) {
      window.removeEventListener("message", this._onCarteiraKanbanAtualizarMessage);
      window.removeEventListener("storage", this._onCarteiraKanbanStorageRefresh);
    }
    if (this._onCarteiraKanbanNovaMensagem) {
      window.removeEventListener("eloca:carteira-kanban-nova-mensagem", this._onCarteiraKanbanNovaMensagem);
    }
    if (this._onCarteiraKanbanLeituraOportunidade) {
      window.removeEventListener("eloca:carteira-kanban-leitura-oportunidade", this._onCarteiraKanbanLeituraOportunidade);
    }
    if (this._onCarteiraKanbanNovoEmail) {
      window.removeEventListener("eloca:carteira-kanban-novo-email", this._onCarteiraKanbanNovoEmail);
    }
    if (this._onCarteiraKanbanLidoEmail) {
      window.removeEventListener("eloca:carteira-kanban-lido-email", this._onCarteiraKanbanLidoEmail);
    }
    if (this._onCarteiraKanbanClienteAtualizado) {
      window.removeEventListener("eloca:carteira-kanban-cliente-atualizado", this._onCarteiraKanbanClienteAtualizado);
    }
    if (this._onCarteiraKanbanDonosAtualizada) {
      window.removeEventListener("eloca:carteira-kanban-donos-atualizada", this._onCarteiraKanbanDonosAtualizada);
    }
    const jq = window.jQuery;
    if (jq) {
      jq("#modalCarteiraKanbanAdicionarClientes").off("hidden.bs.modal.carteiraKanbanAdicionar");
      jq("#modalCarteiraKanbanTarefas").off("hidden.bs.modal.carteiraKanbanTarefas");
    }
  },
  methods: {
    getBoardScrollEl() {
      return this.$refs.boardScroll || null;
    },
    updateBoardScrollHints() {
      const el = this.getBoardScrollEl();
      if (!el) {
        this.boardCanScrollLeft = false;
        this.boardCanScrollRight = false;
        return;
      }
      const tolerance = 2;
      const maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= tolerance) {
        this.boardCanScrollLeft = false;
        this.boardCanScrollRight = false;
        return;
      }
      this.boardCanScrollLeft = el.scrollLeft > tolerance;
      this.boardCanScrollRight = el.scrollLeft < maxScroll - tolerance;
    },
    onBoardScroll() {
      if (this._boardScrollRaf) {
        return;
      }
      this._boardScrollRaf = window.requestAnimationFrame(() => {
        this._boardScrollRaf = null;
        this.updateBoardScrollHints();
      });
    },
    scrollBoardHorizontal(direction) {
      const el = this.getBoardScrollEl();
      if (!el) {
        return;
      }
      el.scrollBy({ left: direction * BOARD_SCROLL_STEP, behavior: "smooth" });
    },
    setupBoardScrollObservers() {
      this.teardownBoardScrollObservers();
      const el = this.getBoardScrollEl();
      if (!el) {
        return;
      }
      this._onBoardWindowResize = () => this.updateBoardScrollHints();
      window.addEventListener("resize", this._onBoardWindowResize, { passive: true });
      if (typeof ResizeObserver !== "undefined") {
        this._boardScrollResizeObserver = new ResizeObserver(() => {
          this.updateBoardScrollHints();
        });
        this._boardScrollResizeObserver.observe(el);
      }
      this.updateBoardScrollHints();
    },
    teardownBoardScrollObservers() {
      if (this._boardScrollRaf) {
        window.cancelAnimationFrame(this._boardScrollRaf);
        this._boardScrollRaf = null;
      }
      if (this._onBoardWindowResize) {
        window.removeEventListener("resize", this._onBoardWindowResize);
        this._onBoardWindowResize = null;
      }
      if (this._boardScrollResizeObserver) {
        this._boardScrollResizeObserver.disconnect();
        this._boardScrollResizeObserver = null;
      }
    },
    syncKanbanOwnerSelectionFromPayload(data) {
      const opts = Array.isArray(data.usuariosKanbanOpcoes) ? data.usuariosKanbanOpcoes : [];
      const ownerId = Number(data.carteiraKanbanOwnerUserId);
      if (!Number.isFinite(ownerId)) {
        this.kanbanOwnerSelection = null;
        return;
      }
      const hit = opts.find((u) => Number(u.id) === ownerId);
      if (hit) {
        this.kanbanOwnerSelection = {
          id: hit.id,
          value: hit.value != null ? hit.value : hit.nome,
        };
      } else {
        this.kanbanOwnerSelection = { id: ownerId, value: `Usuário #${ownerId}` };
      }
    },
    async fetchBootstrap(requestedCarteiraUserId) {
      this.bootstrapLoading = true;
      this.bootstrapError = "";
      try {
        const params = {};
        if (
          requestedCarteiraUserId !== undefined &&
          requestedCarteiraUserId !== null &&
          requestedCarteiraUserId !== ""
        ) {
          const oid = Number(requestedCarteiraUserId);
          if (Number.isFinite(oid) && oid > 0) {
            params.carteira_user_id = oid;
          }
        }
        const { data } = await axios.get(KANBAN_BOOTSTRAP_URL, {
          headers: jsonHeaders,
          params,
        });
        this.gruposFiltro = Array.isArray(data.gruposFiltro) ? data.gruposFiltro : [];
        this.tagsFiltro = Array.isArray(data.tagsFiltro) ? data.tagsFiltro : [];
        if (Array.isArray(data.tarefaFiltros) && data.tarefaFiltros.length) {
          this.tarefaFiltros = data.tarefaFiltros;
        }
        this.routes = data.routes && typeof data.routes === "object" ? data.routes : {};
        this.podeGerenciarCadastro = !!data.podeGerenciarCadastro;
        this.podeGerenciarFasesKanban = !!data.podeGerenciarFasesKanban;
        this.podeMoverCardsKanban = !!data.podeMoverCardsKanban;
        this.podeAdicionarClientesKanban = !!data.podeAdicionarClientesKanban;
        this.podeCriarOportunidade = !!data.podeCriarOportunidade;
        this.carteiraKanbanColunasCompartilhadas = !!data.carteiraKanbanColunasCompartilhadas;
        this.carteiraKanbanUltimaReuniao = !!data.carteiraKanbanUltimaReuniao;
        this.camposKanbanTotais = Array.isArray(data.camposKanbanTotais) ? data.camposKanbanTotais : [];
        this.carteiraKanbanOwnerUserId =
          data.carteiraKanbanOwnerUserId != null ? Number(data.carteiraKanbanOwnerUserId) : null;
        this.carteiraKanbanAuthUserId =
          data.carteiraKanbanAuthUserId != null ? Number(data.carteiraKanbanAuthUserId) : null;
        this.podeVisualizarKanbanOutrosUsuarios = !!data.podeVisualizarKanbanOutrosUsuarios;
        this.usuariosKanbanOpcoes = Array.isArray(data.usuariosKanbanOpcoes)
          ? data.usuariosKanbanOpcoes
          : [];
        if (this.carteiraKanbanColunasCompartilhadas) {
          this.kanbanOwnerSelection = null;
        } else {
          this.kanbanDonoFilterSelection = [];
          this.syncKanbanOwnerSelectionFromPayload(data);
        }
        this.fasesLista = (Array.isArray(data.fases) ? data.fases : []).map((f) => ({
          ...f,
          cor: normalizeHexCor(f.cor),
        }));
        this.bootstrapColumns();
        this.bootstrapLoaded = true;
        this.bootstrapLoading = false;
        this.reloadAll().catch(() => {});
      } catch (e) {
        const d = e.response && e.response.data ? e.response.data : {};
        let msg =
          (typeof d.message === "string" && d.message) ||
          "Não foi possível carregar o Kanban.";
        if (e.response && e.response.status === 403) {
          msg = "Sem permissão para ver o Kanban.";
        }
        if (e.response && e.response.status === 404) {
          msg = "Usuário não encontrado nesta loja.";
        }
        this.bootstrapError = typeof msg === "string" ? msg : JSON.stringify(msg);
        this.bootstrapLoaded = false;
      } finally {
        this.bootstrapLoading = false;
      }
    },
    columnBg(col) {
      return normalizeHexCor(col.cor);
    },
    columnFg(col) {
      return textoSobreCorDeFundo(col.cor);
    },
    cardColumnStripeStyle(col) {
      return {
        "--carteira-card-fase-cor": this.columnBg(col),
      };
    },
    columnCountContrast(col) {
      const fg = (this.columnFg(col) || "").toLowerCase();
      return fg === "#ffffff" ? "light-fg" : "dark-fg";
    },
    displayNome(card) {
      if (card.nome_fantasia) return card.nome_fantasia;
      if (card.razao_social) return card.razao_social;
      return card.nome || "-";
    },
    ultimaReuniaoIndicadorClass(ultimaReuniao) {
      const indicador = ultimaReuniao && ultimaReuniao.indicador;
      if (indicador === "verde") {
        return "text-success";
      }
      if (indicador === "amarelo") {
        return "text-warning";
      }
      if (indicador === "vermelho") {
        return "text-danger";
      }
      return "text-muted";
    },
    ultimaReuniaoIndicadorTitle(ultimaReuniao) {
      const indicador = ultimaReuniao && ultimaReuniao.indicador;
      if (indicador === "verde") {
        return "Verde: última reunião/visita há até 1 mês";
      }
      if (indicador === "amarelo") {
        return "Amarelo: última reunião/visita entre 1 e 3 meses";
      }
      if (indicador === "vermelho") {
        return "Vermelho: última reunião/visita há mais de 3 meses";
      }
      return "";
    },
    formatCurrency(value) {
      return formatCurrencyBr(value);
    },
    emptyTotaisCampos() {
      return (this.camposKanbanTotais || []).map((c) => ({
        campo_id: Number(c.id),
        nome: c.nome,
        total: 0,
      }));
    },
    normalizeTotaisCampos(list) {
      const base = this.emptyTotaisCampos();
      if (!Array.isArray(list) || !list.length) {
        return base;
      }
      const map = {};
      list.forEach((row) => {
        map[Number(row.campo_id)] = row;
      });
      return base.map((b) => {
        const hit = map[b.campo_id];
        return hit
          ? {
              campo_id: b.campo_id,
              nome: hit.nome || b.nome,
              total: Number(hit.total) || 0,
            }
          : b;
      });
    },
    cardCampoNumericoValor(card, campoId) {
      const campos = (card && card.campos_kanban) || [];
      const hit = campos.find((c) => Number(c.id) === Number(campoId) && Number(c.tipo) === 3);
      const n = Number(hit && hit.valor);
      return Number.isFinite(n) ? n : 0;
    },
    cardCampoValorStyle(campo) {
      const cor = campo && campo.cor ? normalizeHexCor(campo.cor) : "#198754";
      return { color: cor };
    },
    adjustColTotaisCampo(col, campoId, delta) {
      if (!col || !Array.isArray(col.totaisCampos)) {
        return;
      }
      col.totaisCampos = col.totaisCampos.map((row) => {
        if (Number(row.campo_id) !== Number(campoId)) {
          return row;
        }
        return {
          ...row,
          total: Math.max(0, (Number(row.total) || 0) + delta),
        };
      });
    },
    tagBadgeStyle(tag) {
      const bg = normalizeHexCor(tag && tag.cor);
      return {
        backgroundColor: bg,
        color: textoSobreCorDeFundo(bg),
        fontSize: "0.65rem",
        padding: "0.25em 0.45em",
      };
    },
    sortFasesList(fases) {
      return [...fases].sort((a, b) => {
        const oa = a.ordem != null ? a.ordem : 0;
        const ob = b.ordem != null ? b.ordem : 0;
        if (oa !== ob) return oa - ob;
        return (a.id || 0) - (b.id || 0);
      });
    },
    sortColumnsList(cols) {
      return [...cols].sort((a, b) => {
        const oa = a.ordem != null ? a.ordem : 0;
        const ob = b.ordem != null ? b.ordem : 0;
        if (oa !== ob) return oa - ob;
        return (a.id || 0) - (b.id || 0);
      });
    },
    createEmptyColumnState(fase) {
      return {
        id: fase.id,
        nome: fase.nome,
        cor: normalizeHexCor(fase.cor),
        ordem: fase.ordem != null ? fase.ordem : 0,
        items: [],
        page: 1,
        lastPage: 1,
        loading: false,
        hasMore: false,
        total: 0,
        totaisCampos: this.emptyTotaisCampos(),
      };
    },
    bootstrapColumns() {
      this.columnsState = this.sortColumnsList(
        this.fasesLista.map((f) => this.createEmptyColumnState(f)),
      );
    },
    appendFaseToState(fase) {
      if (!fase || fase.id == null) return;
      const normalized = {
        ...fase,
        cor: normalizeHexCor(fase.cor),
        ativo: fase.ativo !== false,
      };
      if (!normalized.ativo) return;
      if (this.fasesLista.some((f) => Number(f.id) === Number(normalized.id))) {
        this.updateFaseInState(normalized);
        return;
      }
      this.fasesLista = this.sortFasesList([...this.fasesLista, normalized]);
      this.columnsState = this.sortColumnsList([
        ...this.columnsState,
        this.createEmptyColumnState(normalized),
      ]);
    },
    updateFaseInState(fase) {
      if (!fase || fase.id == null) return;
      const id = Number(fase.id);
      const cor = normalizeHexCor(fase.cor);
      const patch = {
        nome: fase.nome,
        cor,
        ordem: fase.ordem != null ? fase.ordem : 0,
      };
      const fi = this.fasesLista.findIndex((f) => Number(f.id) === id);
      if (fi >= 0) {
        this.$set(this.fasesLista, fi, { ...this.fasesLista[fi], ...fase, ...patch });
      }
      const col = this.columnsState.find((c) => Number(c.id) === id);
      if (col) {
        Object.assign(col, patch);
      }
      this.fasesLista = this.sortFasesList(this.fasesLista);
      this.columnsState = this.sortColumnsList(this.columnsState);
    },
    removeFaseFromState(faseId) {
      const id = Number(faseId);
      this.fasesLista = this.fasesLista.filter((f) => Number(f.id) !== id);
      this.columnsState = this.columnsState.filter((c) => Number(c.id) !== id);
    },
    mergeFasesFromApi(rows) {
      const prevById = new Map(this.columnsState.map((c) => [Number(c.id), c]));
      const fases = this.sortFasesList(
        (Array.isArray(rows) ? rows : [])
          .filter((f) => f.ativo)
          .map((f) => ({ ...f, cor: normalizeHexCor(f.cor) })),
      );
      const nextIds = new Set(fases.map((f) => Number(f.id)));
      this.fasesLista = fases;
      this.columnsState = this.sortColumnsList(
        fases.map((f) => {
          const prev = prevById.get(Number(f.id));
          if (prev) {
            return {
              ...prev,
              nome: f.nome,
              cor: normalizeHexCor(f.cor),
              ordem: f.ordem != null ? f.ordem : 0,
            };
          }
          return this.createEmptyColumnState(f);
        }),
      );
      return {
        addedIds: fases.map((f) => Number(f.id)).filter((fid) => !prevById.has(fid)),
        removedIds: [...prevById.keys()].filter((fid) => !nextIds.has(fid)),
      };
    },
    isSemColunaColumn(col) {
      return !!(col && (col.isSemColuna || col.id === SEM_COLUNA_KANBAN_ID));
    },
    columnBoardKey(col) {
      return this.isSemColunaColumn(col) ? SEM_COLUNA_KANBAN_ID : String(col.id);
    },
    faseUrl(faseId) {
      return String(this.kanbanRoutes.faseClientesTemplate || "").replace("__FASE__", String(faseId));
    },
    semColunaClientesUrl() {
      return (
        this.kanbanRoutes.semColunaClientes || "/painel/carteira/kanban/sem-coluna/clientes"
      );
    },
    toggleSemColunaColumn() {
      if (this.semColunaColumnVisible) {
        this.closeSemColunaColumn();
        return;
      }
      this.semColunaColumnVisible = true;
      this.loadSemColunaPage(1, true);
    },
    closeSemColunaColumn() {
      this.semColunaColumnVisible = false;
      const empty = createSemColunaColumnState();
      Object.assign(this.semColunaColumn, empty);
    },
    async loadSemColunaPage(page, replace) {
      const col = this.semColunaColumn;
      col.loading = true;
      try {
        const params = { page, ...this.commonKanbanParams() };
        const { data } = await axios.get(this.semColunaClientesUrl(), { params });
        this.applyColunaClientesPayload(col, data, replace);
      } finally {
        col.loading = false;
      }
    },
    clientesElegiveisUrl(faseId) {
      const tpl = this.kanbanRoutes.clientesElegiveisTemplate;
      if (!tpl) {
        return `/painel/carteira/kanban/fase/${faseId}/clientes-elegiveis`;
      }
      return String(tpl).replace("__FASE__", String(faseId));
    },
    adicionarClientesPostUrl(faseId) {
      const tpl = this.kanbanRoutes.adicionarClientesTemplate;
      if (!tpl) {
        return `/painel/carteira/kanban/fase/${faseId}/adicionar-clientes`;
      }
      return String(tpl).replace("__FASE__", String(faseId));
    },
    atualizarFaseUrl(clienteId) {
      return String(this.kanbanRoutes.atualizarFaseCliente || "").replace("__CLIENTE__", String(clienteId));
    },
    clienteUrl(clienteId) {
      if (!this.kanbanRoutes.clienteShowTemplate) {
        return `#cliente-${clienteId}`;
      }
      return String(this.kanbanRoutes.clienteShowTemplate).replace("__CLIENTE__", String(clienteId));
    },
    clienteCardUrl(clienteId) {
      const tpl = this.kanbanRoutes.clienteCardTemplate;
      if (!tpl) {
        return `/painel/carteira/kanban/cliente/${clienteId}`;
      }
      return String(tpl).replace("__CLIENTE__", String(clienteId));
    },
    clienteCardPorOportunidadeUrl(oportunidadeId) {
      const tpl = this.kanbanRoutes.clienteCardPorOportunidadeTemplate;
      if (!tpl) {
        return `/painel/carteira/kanban/por-oportunidade/${oportunidadeId}/cliente-card`;
      }
      return String(tpl).replace("__OP__", String(oportunidadeId));
    },
    findCardByOportunidadeId(oportunidadeId) {
      const opId = Number(oportunidadeId);
      if (!Number.isFinite(opId) || opId <= 0) {
        return null;
      }
      for (const col of this.boardColumns) {
        for (const card of col.items || []) {
          const ops = this.oportunidadesAbertas(card);
          if (ops.some((o) => Number(o.id) === opId)) {
            return { col, card, opId };
          }
        }
      }
      return null;
    },
    incrementarMensagensNaoLidasNoCard(hit) {
      const { col, card, opId } = hit;
      const ops = this.sortOportunidadesLista(
        this.oportunidadesAbertas(card).map((o) => {
          if (Number(o.id) !== Number(opId)) {
            return { ...o };
          }
          return {
            ...o,
            mensagens_nao_lidas: (Number(o.mensagens_nao_lidas) || 0) + 1,
          };
        }),
      );
      this.$set(card, "oportunidades_abertas", ops);
      this.$set(
        card,
        "mensagens_nao_lidas_total",
        (Number(card.mensagens_nao_lidas_total) || 0) + 1,
      );
      this.sortKanbanColItems(col);
    },
    async onWsNovaMensagem(oportunidadeId) {
      if (!this.bootstrapLoaded) {
        return;
      }
      const hit = this.findCardByOportunidadeId(oportunidadeId);
      if (hit) {
        this.incrementarMensagensNaoLidasNoCard(hit);
        return;
      }
      await this.refreshClienteCardPorOportunidade(oportunidadeId);
    },
    async onWsLeituraOportunidade(oportunidadeId) {
      if (!this.bootstrapLoaded) {
        return;
      }
      const hit = this.findCardByOportunidadeId(oportunidadeId);
      if (hit) {
        await this.refreshClienteCard(hit.card.id);
        return;
      }
      await this.refreshClienteCardPorOportunidade(oportunidadeId);
    },
    kanbanDonoIdsAtivos() {
      if (this.carteiraKanbanColunasCompartilhadas) {
        return (this.kanbanDonoFilterSelection || [])
          .map((row) => Number(row && row.id))
          .filter((id) => Number.isFinite(id) && id > 0);
      }
      const ownerId = Number(this.carteiraKanbanOwnerUserId);
      const authId = Number(this.carteiraKanbanAuthUserId);
      if (Number.isFinite(ownerId) && ownerId > 0 && ownerId !== authId) {
        return [ownerId];
      }
      return [];
    },
    kanbanOwnerRelevanteParaDono(donoId, donoAnteriorId) {
      const filtroIds = this.kanbanDonoIdsAtivos();
      if (!filtroIds.length) {
        return true;
      }
      const dono = donoId != null ? Number(donoId) : null;
      const donoAnt = donoAnteriorId != null ? Number(donoAnteriorId) : null;
      if (donoAnt != null && filtroIds.includes(donoAnt)) {
        return true;
      }
      if (dono != null && filtroIds.includes(dono)) {
        return true;
      }
      return donoAnt == null && dono == null;
    },
    async onWsClienteCarteiraAtualizado(detail) {
      if (!this.bootstrapLoaded) {
        return;
      }
      const clientePaiId = Number(detail.clientePaiId);
      if (!Number.isFinite(clientePaiId) || clientePaiId <= 0) {
        return;
      }
      if (
        !this.kanbanOwnerRelevanteParaDono(detail.donoId, detail.donoAnteriorId)
      ) {
        const found = this.findColumnWithCliente(clientePaiId);
        if (found) {
          this.removeClienteFromColumns(clientePaiId);
          await this.loadTotais();
        }
        return;
      }
      await this.refreshClienteCard(clientePaiId);
    },
    async onWsCarteiraDonosAtualizada(detail) {
      if (!this.bootstrapLoaded) {
        return;
      }
      const donoIds = (detail && detail.donoIds) || [];
      const ownerId = Number(this.carteiraKanbanOwnerUserId);
      if (
        Number.isFinite(ownerId) &&
        ownerId > 0 &&
        donoIds.length &&
        !donoIds.some((id) => Number(id) === ownerId)
      ) {
        return;
      }
      await this.loadTotais();
      const ids = [];
      for (const col of this.columnsState) {
        for (const card of col.items || []) {
          ids.push(card.id);
        }
      }
      await Promise.all(ids.map((id) => this.refreshClienteCard(id).catch(() => {})));
    },
    async refreshClienteCardPorOportunidade(oportunidadeId) {
      const id = Number(oportunidadeId);
      if (!Number.isFinite(id) || id <= 0) {
        return;
      }
      try {
        const { data } = await axios.get(this.clienteCardPorOportunidadeUrl(id), {
          params: this.commonKanbanParams(),
        });
        this.upsertClienteCard(data);
        await this.loadTotais();
      } catch (_e) {
        /* oportunidade fora da carteira visível */
      }
    },
    findColumnWithCliente(clienteId) {
      const id = Number(clienteId);
      const cols = this.boardColumns;
      for (const col of cols) {
        const idx = (col.items || []).findIndex((c) => Number(c.id) === id);
        if (idx >= 0) {
          return { col, idx };
        }
      }
      return null;
    },
    removeClienteFromColumns(clienteId) {
      const id = Number(clienteId);
      this.columnsState.forEach((col) => {
        col.items = (col.items || []).filter((c) => Number(c.id) !== id);
      });
      if (this.semColunaColumnVisible) {
        this.semColunaColumn.items = (this.semColunaColumn.items || []).filter(
          (c) => Number(c.id) !== id,
        );
      }
    },
    upsertClienteCard(payload) {
      const card = payload && payload.card;
      if (!card || card.id == null) {
        return;
      }
      const faseId = payload.carteira_cliente_fase_id;
      if (!payload.visible) {
        this.removeClienteFromColumns(card.id);
        return;
      }
      if (faseId == null || faseId === "") {
        if (!this.semColunaColumnVisible) {
          this.removeClienteFromColumns(card.id);
          return;
        }
        const foundSem = this.findColumnWithCliente(card.id);
        if (foundSem && this.isSemColunaColumn(foundSem.col)) {
          this.$set(foundSem.col.items, foundSem.idx, card);
          this.sortKanbanColItems(foundSem.col);
          return;
        }
        this.removeClienteFromColumns(card.id);
        this.semColunaColumn.items = this.sortKanbanColItemsArray([
          card,
          ...(this.semColunaColumn.items || []),
        ]);
        return;
      }
      const targetCol = this.columnsState.find((c) => Number(c.id) === Number(faseId));
      if (!targetCol) {
        return;
      }
      const found = this.findColumnWithCliente(card.id);
      if (found && Number(found.col.id) === Number(faseId)) {
        this.$set(found.col.items, found.idx, card);
        this.sortKanbanColItems(found.col);
        return;
      }
      this.removeClienteFromColumns(card.id);
      targetCol.items = [card, ...(targetCol.items || [])];
      this.sortKanbanColItems(targetCol);
    },
    async refreshClienteCard(clienteId) {
      const id = Number(clienteId);
      if (!Number.isFinite(id) || id <= 0) {
        return;
      }
      try {
        const { data } = await axios.get(this.clienteCardUrl(id), {
          params: this.commonKanbanParamsCompleto(),
        });
        this.upsertClienteCard(data);
        await this.loadTotais();
      } catch (_e) {
        /* card pode ter saído da carteira visível */
      }
    },
    oportunidadeUrl(oportunidadeId) {
      const tpl = this.kanbanRoutes.oportunidadeShowTemplate;
      if (!tpl) {
        return `/painel/oportunidades/${oportunidadeId}`;
      }
      return String(tpl).replace("__OP__", String(oportunidadeId));
    },
    oportunidadesAbertas(card) {
      return Array.isArray(card && card.oportunidades_abertas) ? card.oportunidades_abertas : [];
    },
    mensagensNaoLidasTotal(card) {
      const n = card && card.mensagens_nao_lidas_total;
      return Number.isFinite(Number(n)) ? Number(n) : 0;
    },
    mensagensNaoLidasBadge(total) {
      const n = Number(total) || 0;
      return n > 99 ? "99+" : String(n);
    },
    tarefasIndicadorTotal(card) {
      const n = card && card.tarefas_indicador_total;
      return Number.isFinite(Number(n)) ? Number(n) : 0;
    },
    tarefasIndicadorTipo(card) {
      const tipo = card && card.tarefas_indicador;
      if (tipo === "atrasada" || tipo === "hoje" || tipo === "no_prazo") {
        return tipo;
      }
      return null;
    },
    tarefasIndicadorBadgeClass(card) {
      const tipo = this.tarefasIndicadorTipo(card);
      if (tipo === "atrasada") {
        return "carteira-kanban-vue__card-badge--tarefa-atrasada";
      }
      if (tipo === "hoje") {
        return "carteira-kanban-vue__card-badge--tarefa-hoje";
      }
      if (tipo === "no_prazo") {
        return "carteira-kanban-vue__card-badge--tarefa-no-prazo";
      }
      return "";
    },
    tarefasIndicadorTitle(card) {
      const total = this.tarefasIndicadorTotal(card);
      if (!total) {
        return "Tarefas do cliente";
      }
      const base =
        total === 1 ? "1 tarefa aberta" : `${total} tarefas abertas`;
      const tipo = this.tarefasIndicadorTipo(card);
      if (tipo === "atrasada") {
        return `${base} · existem atrasadas`;
      }
      if (tipo === "hoje") {
        return `${base} · existem para hoje`;
      }
      if (tipo === "no_prazo") {
        return `${base} · estão no prazo`;
      }
      return base;
    },
    compareOportunidadesKanban(a, b) {
      const na = Number(a && a.mensagens_nao_lidas) || 0;
      const nb = Number(b && b.mensagens_nao_lidas) || 0;
      if (nb !== na) {
        return nb - na;
      }
      return (Number(b && b.id) || 0) - (Number(a && a.id) || 0);
    },
    sortOportunidadesLista(list) {
      if (!Array.isArray(list) || !list.length) {
        return [];
      }
      return list.slice().sort((a, b) => this.compareOportunidadesKanban(a, b));
    },
    prioridadeTarefaCard(card) {
      const tipo = this.tarefasIndicadorTipo(card);
      if (tipo === "atrasada") {
        return 3;
      }
      if (tipo === "hoje") {
        return 2;
      }
      if (tipo === "no_prazo") {
        return 1;
      }
      return 0;
    },
    compareKanbanCards(a, b) {
      const msgA = this.mensagensNaoLidasTotal(a);
      const msgB = this.mensagensNaoLidasTotal(b);
      if (msgB !== msgA) {
        return msgB - msgA;
      }
      const prioA = this.prioridadeTarefaCard(a);
      const prioB = this.prioridadeTarefaCard(b);
      if (prioB !== prioA) {
        return prioB - prioA;
      }
      const tarefasA = this.tarefasIndicadorTotal(a);
      const tarefasB = this.tarefasIndicadorTotal(b);
      if (tarefasB !== tarefasA) {
        return tarefasB - tarefasA;
      }
      return (Number(b && b.id) || 0) - (Number(a && a.id) || 0);
    },
    sortKanbanColItemsArray(items) {
      if (!Array.isArray(items) || items.length < 2) {
        return items || [];
      }
      return items.slice().sort((a, b) => this.compareKanbanCards(a, b));
    },
    sortKanbanColItems(col) {
      if (!col || !Array.isArray(col.items) || col.items.length < 2) {
        return;
      }
      this.$set(col, "items", this.sortKanbanColItemsArray(col.items));
    },
    opFaseChipStyle(op) {
      const cor = op && op.fase_cor ? normalizeHexCor(op.fase_cor) : null;
      if (!cor) {
        return {};
      }
      return {
        backgroundColor: cor,
        color: textoSobreCorDeFundo(cor),
        borderColor: cor,
      };
    },
    opCanalLabel(op) {
      if (!op) {
        return "";
      }
      if (op.canal_label) {
        return op.canal_label;
      }
      const canal = op.canal ? String(op.canal).trim() : "";
      if (!canal) {
        return "";
      }
      return canal.charAt(0).toUpperCase() + canal.slice(1).toLowerCase();
    },
    opCanalIconClass(op) {
      const canal = op && op.canal ? String(op.canal).toLowerCase() : "";
      const map = {
        whatsapp: "fab fa-whatsapp text-success",
        email: "far fa-envelope",
        telefone: "fas fa-phone text-success",
        telegram: "fab fa-telegram text-primary",
        presencial: "fas fa-user",
        messenger: "fab fa-facebook-messenger text-primary",
        instagram: "fab fa-instagram text-danger",
        api: "fas fa-exchange-alt text-primary",
      };
      return map[canal] || "fas fa-pencil-alt text-muted";
    },
    oportunidadeOpenUrl(op) {
      const base = op.url || this.oportunidadeUrl(op.id);
      const chatNaoLidas = Number(op.chat_nao_lidas) || 0;
      const emailNaoLidos = Number(op.email_nao_lidos) || 0;
      const total = Number(op.mensagens_nao_lidas) || 0;
      if (total <= 0 && chatNaoLidas <= 0 && emailNaoLidos <= 0) {
        return base;
      }
      const params = new URLSearchParams();
      if (chatNaoLidas > 0) {
        params.set("focus_chat", "1");
        if (op.chat_config_hub_id) {
          params.set("config_hub_id", String(op.chat_config_hub_id));
        }
        if (op.primeira_mensagem_nao_lida_id) {
          params.set("msg_nao_lida_id", String(op.primeira_mensagem_nao_lida_id));
        }
      } else if (emailNaoLidos > 0) {
        params.set("focus_email", "1");
      } else {
        params.set("focus_chat", "1");
      }
      const sep = base.indexOf("?") !== -1 ? "&" : "?";
      return base + sep + params.toString();
    },
    resolvePainelUrl(url) {
      if (!url) {
        return "";
      }
      if (/^https?:\/\//i.test(url)) {
        return url;
      }
      if (typeof window.siteUrl === "function") {
        return window.siteUrl(url);
      }
      return url;
    },
    openPainelIframeModal(pathOrUrl) {
      let href = this.resolvePainelUrl(pathOrUrl);
      if (!href) {
        return;
      }
      const sep = href.indexOf("?") !== -1 ? "&" : "?";
      const fullUrl = href.includes("kanban_modal") ? href : href + sep + "kanban_modal=1";
      if (typeof window.elocaAbrirModalIframePainel === "function") {
        window.elocaAbrirModalIframePainel(fullUrl);
        return;
      }
      window.location.href = fullUrl;
    },
    oportunidadeRailTitle(card) {
      const ops = this.oportunidadesAbertas(card);
      if (ops.length > 0) {
        return "Oportunidades em aberto";
      }
      if (this.podeCriarOportunidade) {
        return "Nova oportunidade";
      }
      return "Oportunidades em aberto";
    },
    clienteOportunidadeStoreUrl(clienteId) {
      const tpl = this.kanbanRoutes.clienteOportunidadeStoreTemplate;
      if (!tpl) {
        return `/painel/carteira/kanban/cliente/${clienteId}/oportunidades`;
      }
      return String(tpl).replace("__CLIENTE__", String(clienteId));
    },
    clienteOportunidadesEncerradasUrl(clienteId) {
      const tpl = this.kanbanRoutes.clienteOportunidadesEncerradasTemplate;
      if (!tpl) {
        return `/painel/carteira/kanban/cliente/${clienteId}/oportunidades-encerradas`;
      }
      return String(tpl).replace("__CLIENTE__", String(clienteId));
    },
    clienteNotasUrl(clienteId) {
      const tpl = this.kanbanRoutes.clienteNotasTemplate;
      if (!tpl) {
        return `/painel/carteira/kanban/cliente/${clienteId}/notas`;
      }
      return String(tpl).replace("__CLIENTE__", String(clienteId));
    },
    resetOportunidadeEncerradas() {
      this.oportunidadeEncerradasLoadSeq += 1;
      this.oportunidadeEncerradas = [];
      this.oportunidadeEncerradasTotal = 0;
      this.oportunidadeEncerradasHasMore = false;
      this.oportunidadeEncerradasLoading = false;
      this.oportunidadeEncerradasLoadingMore = false;
      this.oportunidadeEncerradasErro = "";
    },
    setOportunidadePickerAba(aba) {
      if (this.oportunidadePickerAba === aba) {
        return;
      }
      this.oportunidadePickerAba = aba;
      if (aba === "encerradas") {
        this.loadOportunidadesEncerradas(true);
      }
    },
    async loadOportunidadesEncerradas(reset) {
      const card = this.oportunidadePickerCard;
      if (!card) {
        return;
      }
      if (reset) {
        this.oportunidadeEncerradas = [];
        this.oportunidadeEncerradasHasMore = false;
        this.oportunidadeEncerradasErro = "";
      }
      const seq = ++this.oportunidadeEncerradasLoadSeq;
      const offset = reset ? 0 : this.oportunidadeEncerradas.length;
      if (reset) {
        this.oportunidadeEncerradasLoading = true;
      } else {
        this.oportunidadeEncerradasLoadingMore = true;
      }
      try {
        const { data } = await axios.get(this.clienteOportunidadesEncerradasUrl(card.id), {
          params: { offset },
          headers: jsonHeaders,
        });
        if (seq !== this.oportunidadeEncerradasLoadSeq) {
          return;
        }
        const items = Array.isArray(data.data) ? data.data : [];
        this.oportunidadeEncerradas = reset ? items : this.oportunidadeEncerradas.concat(items);
        this.oportunidadeEncerradasTotal = Number(data.total) || this.oportunidadeEncerradas.length;
        this.oportunidadeEncerradasHasMore = !!data.has_more;
      } catch (err) {
        if (seq !== this.oportunidadeEncerradasLoadSeq) {
          return;
        }
        const msg = err.response && err.response.data && err.response.data.message;
        this.oportunidadeEncerradasErro =
          (typeof msg === "string" && msg) || "Não foi possível carregar as oportunidades encerradas.";
      } finally {
        if (seq === this.oportunidadeEncerradasLoadSeq) {
          this.oportunidadeEncerradasLoading = false;
          this.oportunidadeEncerradasLoadingMore = false;
        }
      }
    },
    carregarMaisOportunidadesEncerradas() {
      if (this.oportunidadeEncerradasLoadingMore || !this.oportunidadeEncerradasHasMore) {
        return;
      }
      this.loadOportunidadesEncerradas(false);
    },
    async criarOportunidadeKanban() {
      const card = this.oportunidadePickerCard;
      if (!card || !this.podeCriarOportunidade || this.oportunidadeCriando) {
        return;
      }
      this.oportunidadeCriando = true;
      this.oportunidadePickerErro = "";
      try {
        const { data } = await axios.post(
          this.clienteOportunidadeStoreUrl(card.id),
          {},
          { headers: jsonHeaders },
        );
        const op = data.oportunidade;
        await this.refreshClienteCard(card.id);
        if (op) {
          this.openPainelIframeModal(this.oportunidadeOpenUrl(op));
        }
      } catch (err) {
        const msg = err.response?.data?.message;
        this.oportunidadePickerErro = msg || "Não foi possível criar a oportunidade.";
      } finally {
        this.oportunidadeCriando = false;
      }
    },
    async onCardOportunidadeClick(card) {
      const ops = this.oportunidadesAbertas(card);
      this.oportunidadePickerCard = card;
      this.oportunidadePickerErro = "";
      this.oportunidadePickerLoading = false;
      this.oportunidadePickerAba = "abertas";
      this.resetOportunidadeEncerradas();

      const precisaDetalhes = ops.length > 0 && ops.some((op) => op.leve || !op.url);
      if (precisaDetalhes) {
        this.oportunidadePickerLoading = true;
        bs$("#modalCarteiraKanbanOportunidades").modal("show");
        try {
          const { data } = await axios.get(this.clienteCardUrl(card.id), {
            params: this.commonKanbanParamsCompleto(),
          });
          if (data && data.card) {
            this.$set(card, "oportunidades_abertas", data.card.oportunidades_abertas || []);
            this.$set(
              card,
              "mensagens_nao_lidas_total",
              Number(data.card.mensagens_nao_lidas_total) || 0,
            );
          }
        } catch (err) {
          const msg = err.response && err.response.data && err.response.data.message;
          this.oportunidadePickerErro =
            (typeof msg === "string" && msg) || "Não foi possível carregar as oportunidades.";
        } finally {
          this.oportunidadePickerLoading = false;
        }
        return;
      }

      this.$nextTick(() => {
        bs$("#modalCarteiraKanbanOportunidades").modal("show");
      });
    },
    processarAtualizacaoCarteiraKanbanCliente(data, eventSource) {
      if (!data || data.type !== "elocaCarteiraKanbanAtualizar") {
        return;
      }
      const iframe = document.getElementById("iframeOportunidadeFullscreen");
      if (eventSource && iframe && iframe.contentWindow) {
        if (eventSource !== iframe.contentWindow) {
          return;
        }
      }
      const clienteId = data.clienteId || data.clientePaiId;
      if (clienteId) {
        this.refreshClienteCard(clienteId);
      }
    },
    onCardClienteClick(card) {
      this.openPainelIframeModal(this.clienteUrl(card.id));
    },
    clienteTarefasUrl(clienteId) {
      const tpl = this.kanbanRoutes.clienteTarefasTemplate;
      if (!tpl) {
        return `/painel/carteira/kanban/cliente/${clienteId}/tarefas`;
      }
      return String(tpl).replace("__CLIENTE__", String(clienteId));
    },
    clienteTarefaConcluirUrl(clienteId, tarefaId) {
      const tpl = this.kanbanRoutes.clienteTarefaConcluirTemplate;
      if (!tpl) {
        return `/painel/carteira/kanban/cliente/${clienteId}/tarefas/${tarefaId}/concluir`;
      }
      return String(tpl)
        .replace("__CLIENTE__", String(clienteId))
        .replace("__TAREFA__", String(tarefaId));
    },
    resetTarefaPickerForm(meta) {
      const m = meta || this.tarefaPickerFormMeta;
      const defaultClienteId =
        m.default_cliente_id != null ? String(m.default_cliente_id) : "";
      this.tarefaPickerForm = {
        cliente_id: defaultClienteId,
        titulo: "",
        tipo: "",
        user_id: m.default_user_id != null ? String(m.default_user_id) : "",
        data: m.default_data || "",
        hora: m.default_hora || "",
        descricao: "",
        template_id: "",
      };
    },
    onTarefaKanbanContatoChange() {
      this.tarefaPickerForm.template_id = "";
    },
    resetTarefaPickerModal() {
      this.tarefaPickerLoadSeq += 1;
      this.tarefaPickerCard = null;
      this.tarefaPickerLoading = false;
      this.tarefaConcluindoId = null;
      this.tarefaPickerSaving = false;
      this.tarefaPickerErro = "";
      this.tarefaPickerTarefas = [];
      this.tarefaPickerPodeCriar = false;
      this.tarefaPickerShowForm = false;
      this.tarefaPickerVerConcluidas = false;
      this.tarefaPickerAba = "tarefas";
      this.tarefaNotasLoadSeq += 1;
      this.tarefaNotas = [];
      this.tarefaNotasTotal = 0;
      this.tarefaNotasHasMore = false;
      this.tarefaNotasLoading = false;
      this.tarefaNotasLoadingMore = false;
      this.tarefaNotasErro = "";
    },
    async loadTarefasKanban(card) {
      const clienteId = card && card.id;
      if (!clienteId) {
        this.tarefaPickerLoading = false;
        return;
      }
      const seq = ++this.tarefaPickerLoadSeq;
      this.tarefaPickerLoading = true;
      this.tarefaPickerErro = "";
      try {
        const { data } = await axios.get(this.clienteTarefasUrl(clienteId), {
          headers: jsonHeaders,
        });
        if (seq !== this.tarefaPickerLoadSeq) {
          return;
        }
        this.tarefaPickerTarefas = Array.isArray(data.tarefas) ? data.tarefas : [];
        this.tarefaPickerPodeCriar = !!data.pode_criar;
        this.tarefaPickerFormMeta = {
          tipos: data.form?.tipos || [],
          users: data.form?.users || [],
          contatos: data.form?.contatos || [],
          templates_por_cliente: data.form?.templates_por_cliente || {},
          default_cliente_id: data.form?.default_cliente_id ?? null,
          default_user_id: data.form?.default_user_id,
          default_data: data.form?.default_data,
          default_hora: data.form?.default_hora,
        };
        this.resetTarefaPickerForm(this.tarefaPickerFormMeta);
      } catch (err) {
        if (seq !== this.tarefaPickerLoadSeq) {
          return;
        }
        this.tarefaPickerTarefas = [];
        this.tarefaPickerErro =
          (err.response && err.response.data && err.response.data.message) ||
          "Não foi possível carregar as tarefas.";
      } finally {
        if (seq === this.tarefaPickerLoadSeq) {
          this.tarefaPickerLoading = false;
        }
      }
    },
    onCardTarefasClick(card) {
      this.tarefaPickerCard = card;
      this.tarefaPickerShowForm = false;
      this.tarefaPickerVerConcluidas = false;
      this.tarefaPickerAba = "tarefas";
      this.tarefaPickerTarefas = [];
      this.tarefaPickerErro = "";
      this.tarefaPickerLoading = true;
      this.tarefaNotas = [];
      this.tarefaNotasTotal = 0;
      this.tarefaNotasHasMore = false;
      this.tarefaNotasErro = "";
      this.$nextTick(() => {
        bs$("#modalCarteiraKanbanTarefas").modal("show");
        this.loadTarefasKanban(card);
      });
    },
    setTarefaPickerAba(aba) {
      if (this.tarefaPickerAba === aba) {
        return;
      }
      this.tarefaPickerAba = aba;
      if (aba === "notas") {
        this.loadNotasKanban(true);
      }
    },
    notaOrigemLabel(nota) {
      if (!nota) {
        return "Nota";
      }
      if (nota.origem === "oportunidade") {
        return nota.oportunidade_nome || "Oportunidade";
      }
      return "Cliente";
    },
    async loadNotasKanban(reset) {
      const card = this.tarefaPickerCard;
      if (!card) {
        return;
      }
      if (reset) {
        this.tarefaNotas = [];
        this.tarefaNotasHasMore = false;
        this.tarefaNotasErro = "";
      }
      const seq = ++this.tarefaNotasLoadSeq;
      const offset = reset ? 0 : this.tarefaNotas.length;
      if (reset) {
        this.tarefaNotasLoading = true;
      } else {
        this.tarefaNotasLoadingMore = true;
      }
      try {
        const { data } = await axios.get(this.clienteNotasUrl(card.id), {
          params: { offset },
          headers: jsonHeaders,
        });
        if (seq !== this.tarefaNotasLoadSeq) {
          return;
        }
        const items = Array.isArray(data.data) ? data.data : [];
        this.tarefaNotas = reset ? items : this.tarefaNotas.concat(items);
        this.tarefaNotasTotal = Number(data.total) || this.tarefaNotas.length;
        this.tarefaNotasHasMore = !!data.has_more;
      } catch (err) {
        if (seq !== this.tarefaNotasLoadSeq) {
          return;
        }
        const msg = err.response && err.response.data && err.response.data.message;
        this.tarefaNotasErro =
          (typeof msg === "string" && msg) || "Não foi possível carregar as notas.";
      } finally {
        if (seq === this.tarefaNotasLoadSeq) {
          this.tarefaNotasLoading = false;
          this.tarefaNotasLoadingMore = false;
        }
      }
    },
    carregarMaisNotasKanban() {
      if (this.tarefaNotasLoadingMore || !this.tarefaNotasHasMore) {
        return;
      }
      this.loadNotasKanban(false);
    },
    abrirFormTarefaKanban() {
      this.tarefaPickerErro = "";
      this.resetTarefaPickerForm();
      this.tarefaPickerShowForm = true;
    },
    cancelarFormTarefaKanban() {
      this.tarefaPickerShowForm = false;
      this.tarefaPickerErro = "";
      this.resetTarefaPickerForm();
    },
    validarFormTarefaKanban() {
      const f = this.tarefaPickerForm;
      if (this.tarefaPickerMostraSeletorContato && !f.cliente_id) {
        return "Selecione o contato da tarefa.";
      }
      if (!String(f.titulo || "").trim()) {
        return "Informe o título da tarefa.";
      }
      if (!f.tipo) {
        return "Selecione o tipo da tarefa.";
      }
      if (!f.user_id) {
        return "Selecione o responsável pela tarefa.";
      }
      if (!f.data) {
        return "Informe a data da tarefa.";
      }
      if (!f.hora) {
        return "Informe o horário da tarefa.";
      }
      if (this.tarefaPickerFormWhatsapp && !f.template_id) {
        return "Selecione a mensagem de ativação do WhatsApp.";
      }
      return "";
    },
    normalizarHoraTarefaKanban(hora) {
      const raw = String(hora || "").trim();
      const match = raw.match(/^(\d{1,2}):(\d{2})/);
      if (!match) {
        return "";
      }
      return `${String(match[1]).padStart(2, "0")}:${match[2]}`;
    },
    atualizarTarefaNoPicker(tarefaAtualizada) {
      if (!tarefaAtualizada || !tarefaAtualizada.id) {
        return;
      }
      const idx = this.tarefaPickerTarefas.findIndex((t) => t.id === tarefaAtualizada.id);
      if (idx === -1) {
        return;
      }
      this.$set(this.tarefaPickerTarefas, idx, tarefaAtualizada);
    },
    async concluirTarefaKanban(tarefa) {
      if (!tarefa || !this.tarefaPickerCard || tarefa.concluida || !tarefa.pode_concluir) {
        return;
      }
      this.tarefaConcluindoId = tarefa.id;
      this.tarefaPickerErro = "";
      try {
        const { data } = await axios.patch(
          this.clienteTarefaConcluirUrl(this.tarefaPickerCard.id, tarefa.id),
          {},
          { headers: jsonHeaders },
        );
        if (data.tarefa) {
          this.atualizarTarefaNoPicker(data.tarefa);
        }
        if (this.tarefaPickerCard) {
          await this.refreshClienteCard(this.tarefaPickerCard.id);
        }
      } catch (err) {
        const msg = err.response?.data?.message;
        this.tarefaPickerErro = msg || "Não foi possível concluir a tarefa.";
      } finally {
        this.tarefaConcluindoId = null;
      }
    },
    async salvarTarefaKanban() {
      if (this.tarefaPickerSaving) {
        return;
      }
      if (!this.tarefaPickerCard) {
        this.tarefaPickerErro = "Cliente não identificado.";
        return;
      }
      if (!this.tarefaPickerPodeCriar) {
        this.tarefaPickerErro = "Sem permissão para criar tarefas.";
        return;
      }
      const erroValidacao = this.validarFormTarefaKanban();
      if (erroValidacao) {
        this.tarefaPickerErro = erroValidacao;
        return;
      }
      const hora = this.normalizarHoraTarefaKanban(this.tarefaPickerForm.hora);
      if (!hora) {
        this.tarefaPickerErro = "Horário inválido.";
        return;
      }
      this.tarefaPickerSaving = true;
      this.tarefaPickerErro = "";
      try {
        const payload = {
          titulo: String(this.tarefaPickerForm.titulo).trim(),
          tipo: this.tarefaPickerForm.tipo,
          user_id: Number(this.tarefaPickerForm.user_id),
          data: this.tarefaPickerForm.data,
          hora,
          descricao: this.tarefaPickerForm.descricao || "",
          template_id: this.tarefaPickerFormWhatsapp
            ? Number(this.tarefaPickerForm.template_id) || null
            : null,
        };
        if (this.tarefaPickerMostraSeletorContato) {
          payload.cliente_id = Number(this.tarefaPickerForm.cliente_id);
        }
        const { data } = await axios.post(
          this.clienteTarefasUrl(this.tarefaPickerCard.id),
          payload,
          { headers: jsonHeaders },
        );
        if (data.tarefa) {
          this.tarefaPickerTarefas = [data.tarefa, ...this.tarefaPickerTarefas];
        } else {
          await this.loadTarefasKanban(this.tarefaPickerCard);
        }
        this.tarefaPickerShowForm = false;
        this.resetTarefaPickerForm();
        try {
          await this.refreshClienteCard(this.tarefaPickerCard.id);
        } catch (_e) {
          /* indicador do card atualiza no próximo refresh do board */
        }
      } catch (err) {
        const msg = err.response?.data?.message;
        const errors = err.response?.data?.errors;
        if (errors && typeof errors === "object") {
          const first = Object.values(errors).flat()[0];
          this.tarefaPickerErro = first || msg || "Não foi possível salvar a tarefa.";
        } else {
          this.tarefaPickerErro = msg || "Não foi possível salvar a tarefa.";
        }
      } finally {
        this.tarefaPickerSaving = false;
      }
    },
    abrirOportunidadeDaTarefa(tarefa) {
      if (!tarefa || !tarefa.oportunidade_id) {
        return;
      }
      bs$("#modalCarteiraKanbanTarefas").modal("hide");
      this.resetTarefaPickerModal();
      const tpl = this.kanbanRoutes.oportunidadeShowTemplate;
      const url = tpl
        ? String(tpl).replace("__OP__", String(tarefa.oportunidade_id))
        : `/painel/oportunidades/${tarefa.oportunidade_id}`;
      this.openPainelIframeModal(url);
    },
    abrirOportunidade(op) {
      if (!op) {
        return;
      }
      this.openPainelIframeModal(this.oportunidadeOpenUrl(op));
    },
    async reloadAll() {
      const overlay = this.bootstrapLoaded && !this.bootstrapLoading;
      if (overlay) {
        this.boardRefreshing = true;
      }
      try {
        for (const col of this.columnsState) {
          col.page = 1;
          col.items = [];
          col.hasMore = false;
        }
        const loads = [this.loadColunasEmLotes()];
        if (this.semColunaColumnVisible) {
          loads.push(this.loadSemColunaPage(1, true));
        }
        await Promise.all(loads);
      } finally {
        if (overlay) {
          this.boardRefreshing = false;
        }
      }
    },
    aplicarFiltros() {
      if (!this.bootstrapLoaded) return;
      this.reloadAll();
    },
    async limparFiltros() {
      this.kanbanBuscaNome = "";
      this.kanbanTarefaStatus = "";
      this.grupoSelection = [];
      this.tagSelection = [];
      if (this.podeVisualizarKanbanOutrosUsuarios) {
        if (this.carteiraKanbanColunasCompartilhadas) {
          this.kanbanDonoFilterSelection = [];
          if (this.bootstrapLoaded) {
            await this.reloadAll();
          }
          return;
        }
        this.kanbanOwnerSelection = null;
        await this.fetchBootstrap();
        return;
      }
      if (this.bootstrapLoaded) {
        await this.reloadAll();
      }
    },
    grupoFilterParams() {
      const ids = (this.grupoSelection || [])
        .map((row) => row && row.id)
        .filter((id) => id !== "" && id !== null && id !== undefined);
      if (!ids.length) {
        return {};
      }
      const numeric = ids
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0);
      if (!numeric.length) {
        return {};
      }
      return { b2b_grupo_ids: numeric };
    },
    tagFilterParams() {
      const values = (this.tagSelection || [])
        .map((row) => row && row.id)
        .filter((id) => id !== "" && id !== null && id !== undefined);
      if (!values.length) {
        return {};
      }
      const hasSemTag = values.some((id) => id === "sem_tag");
      if (hasSemTag) {
        return { tags: ["sem_tag"] };
      }
      const numeric = values
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0);
      if (!numeric.length) {
        return {};
      }
      return { tags: numeric };
    },
    kanbanOwnerQueryParams() {
      const id = Number(this.carteiraKanbanOwnerUserId);
      const authId = Number(this.carteiraKanbanAuthUserId);
      if (!Number.isFinite(id) || id <= 0 || !Number.isFinite(authId)) {
        return {};
      }
      if (id === authId) {
        return {};
      }
      return { carteira_user_id: id };
    },
    kanbanDonoFilterQueryParams() {
      const ids = (this.kanbanDonoFilterSelection || [])
        .map((row) => Number(row && row.id))
        .filter((id) => Number.isFinite(id) && id > 0);
      if (!ids.length) {
        return {};
      }
      return { carteira_user_ids: ids };
    },
    kanbanUsuarioFilterQueryParams() {
      if (this.carteiraKanbanColunasCompartilhadas) {
        return this.kanbanDonoFilterQueryParams();
      }
      return this.kanbanOwnerQueryParams();
    },
    nomeFilterParams() {
      const nome = (this.kanbanBuscaNome || "").trim();
      if (!nome) {
        return {};
      }
      return { nome };
    },
    tarefaFilterParams() {
      const status = (this.kanbanTarefaStatus || "").trim();
      if (!status) {
        return {};
      }
      return { tarefa_status: status };
    },
    commonKanbanParams() {
      return {
        modo: "leve",
        ...this.nomeFilterParams(),
        ...this.grupoFilterParams(),
        ...this.tagFilterParams(),
        ...this.tarefaFilterParams(),
        ...this.kanbanUsuarioFilterQueryParams(),
      };
    },
    commonKanbanParamsCompleto() {
      return {
        ...this.commonKanbanParams(),
        modo: "completo",
      };
    },
    onTarefaFilterSelect(selection) {
      this.kanbanTarefaStatus =
        selection && selection.id != null && String(selection.id) !== ""
          ? String(selection.id)
          : "";
    },
    onKanbanDonoFilterSelect(selection) {
      this.kanbanDonoFilterSelection = Array.isArray(selection) ? selection : [];
    },
    async onKanbanOwnerSelect(selection) {
      if (!selection || selection.id == null || selection.id === "") {
        this.kanbanOwnerSelection = null;
        await this.fetchBootstrap();
        return;
      }
      this.kanbanOwnerSelection = selection;
      const id = Number(selection.id);
      if (!Number.isFinite(id) || id <= 0) {
        return;
      }
      await this.fetchBootstrap(id);
    },
    async loadTotais() {
      const params = this.commonKanbanParams();
      const { data } = await axios.get(this.kanbanRoutes.totais, { params });
      const map = data.fases || {};
      this.columnsState.forEach((col) => {
        const entry = map[col.id];
        col.total = entry && entry.count ? entry.count : 0;
        col.totaisCampos = this.normalizeTotaisCampos(entry && entry.totais_campos);
      });
      const sem = data.sem_coluna;
      this.semColunaColumn.total = sem && sem.count ? Number(sem.count) : 0;
      this.semColunaColumn.totaisCampos = this.normalizeTotaisCampos(sem && sem.totais_campos);
    },
    applyColunaClientesPayload(col, data, replace) {
      const chunk = data.data || [];
      col.lastPage = data.last_page || 1;
      col.page = data.current_page || 1;
      col.items = this.sortKanbanColItemsArray(
        replace ? chunk : (col.items || []).concat(chunk),
      );
      col.hasMore = col.page < col.lastPage;
    },
    async loadColunasEmLotes(cols = null) {
      const targetCols = cols || this.columnsState;
      if (!targetCols.length) {
        await this.loadTotais();
        return;
      }

      const batches = [];
      for (let i = 0; i < targetCols.length; i += KANBAN_COLUNAS_BATCH_SIZE) {
        batches.push(targetCols.slice(i, i + KANBAN_COLUNAS_BATCH_SIZE));
      }

      await this.loadColunasBatch(batches[0]);

      const restLoads = batches.slice(1).map((batch) => this.loadColunasBatch(batch));
      restLoads.push(this.loadTotais());
      await Promise.all(restLoads);
    },
    async loadColunasBatch(cols) {
      if (!cols || !cols.length) {
        return;
      }

      const url = this.kanbanRoutes.colunasClientes;
      if (!url) {
        await Promise.all(cols.map((col) => this.loadPage(col, 1, true)));
        return;
      }

      cols.forEach((col) => {
        col.loading = true;
      });
      try {
        const params = {
          page: 1,
          fase_ids: cols.map((c) => c.id),
          ...this.commonKanbanParams(),
        };
        const { data } = await axios.get(url, { params });
        const columns = data.columns || {};
        cols.forEach((col) => {
          const payload = columns[col.id] ?? columns[String(col.id)];
          if (payload) {
            this.applyColunaClientesPayload(col, payload, true);
          } else {
            col.items = [];
            col.page = 1;
            col.lastPage = 1;
            col.hasMore = false;
          }
        });
      } finally {
        cols.forEach((col) => {
          col.loading = false;
        });
      }
    },
    async loadTodasColunasPrimeiraPagina() {
      await this.loadColunasEmLotes();
    },
    async loadPage(col, page, replace) {
      if (this.isSemColunaColumn(col)) {
        return this.loadSemColunaPage(page, replace);
      }
      col.loading = true;
      try {
        const params = { page, ...this.commonKanbanParams() };
        const { data } = await axios.get(this.faseUrl(col.id), { params });
        this.applyColunaClientesPayload(col, data, replace);
      } finally {
        col.loading = false;
      }
    },
    async loadMore(col) {
      if (col.loading || !col.hasMore) return;
      await this.loadPage(col, col.page + 1, false);
    },
    resetAdicionarClientesModal() {
      this.adicionarClientesCol = null;
      this.adicionarClientesFaseId = null;
      this.adicionarClientesBusca = "";
      this.adicionarClientesLista = [];
      this.adicionarClientesSelected = {};
      this.adicionarClientesSelectedRows = {};
      this.adicionarClientesPage = 1;
      this.adicionarClientesLastPage = 1;
      this.adicionarClientesLoading = false;
      this.adicionarClientesLoadSeq = 0;
      this.adicionarClientesSaving = false;
      this.adicionarClientesErro = "";
    },
    prepareAdicionarClientesModal(col) {
      this.adicionarClientesCol = col;
      this.adicionarClientesFaseId = col && col.id != null ? Number(col.id) : null;
      this.adicionarClientesBusca = "";
      this.adicionarClientesLista = [];
      this.adicionarClientesSelected = {};
      this.adicionarClientesSelectedRows = {};
      this.adicionarClientesPage = 1;
      this.adicionarClientesLastPage = 1;
      this.adicionarClientesLoading = false;
      this.adicionarClientesLoadSeq = 0;
      this.adicionarClientesSaving = false;
      this.adicionarClientesErro = "";
    },
    openAdicionarClientesModal(col) {
      if (!col || !this.podeAdicionarClientesKanban) {
        return;
      }
      this.prepareAdicionarClientesModal(col);
      const carregarInicial = () => {
        if (!this.adicionarClientesFaseId) {
          return;
        }
        this.loadClientesElegiveis(true);
      };
      const jq = window.jQuery;
      if (jq) {
        const $modal = jq("#modalCarteiraKanbanAdicionarClientes");
        $modal
          .off("shown.bs.modal.carteiraKanbanAdicionarInicial")
          .one("shown.bs.modal.carteiraKanbanAdicionarInicial", carregarInicial);
        $modal.modal("show");
      } else {
        this.$nextTick(carregarInicial);
      }
    },
    closeAdicionarClientesModal() {
      const jq = window.jQuery;
      if (jq) {
        jq("#modalCarteiraKanbanAdicionarClientes").modal("hide");
      } else {
        this.resetAdicionarClientesModal();
      }
    },
    buscarClientesElegiveis() {
      return this.loadClientesElegiveis(true);
    },
    isAdicionarClienteSelected(id) {
      return !!this.adicionarClientesSelected[String(id)];
    },
    isAdicionarClienteForaDaBusca(id) {
      const key = String(id);
      if (!this.adicionarClientesSelected[key]) {
        return false;
      }
      return !(this.adicionarClientesLista || []).some((r) => String(r.id) === key);
    },
    syncAdicionarClientesSelectedRows(items) {
      if (!Array.isArray(items)) {
        return;
      }
      items.forEach((row) => {
        const key = String(row.id);
        if (this.adicionarClientesSelected[key]) {
          this.$set(this.adicionarClientesSelectedRows, key, row);
        }
      });
    },
    toggleAdicionarCliente(row) {
      const key = String(row.id);
      const next = !this.adicionarClientesSelected[key];
      this.$set(this.adicionarClientesSelected, key, next);
      if (next) {
        this.$set(this.adicionarClientesSelectedRows, key, row);
      } else {
        this.$delete(this.adicionarClientesSelectedRows, key);
      }
    },
    async loadClientesElegiveis(reset) {
      const faseId = this.adicionarClientesFaseId;
      if (!faseId) {
        return;
      }
      const page = reset ? 1 : (Number(this.adicionarClientesPage) || 0) + 1;
      if (reset) {
        this.adicionarClientesErro = "";
      }
      const seq = ++this.adicionarClientesLoadSeq;
      this.adicionarClientesLoading = true;
      try {
        const params = {
          page,
          ...this.commonKanbanParams(),
        };
        const q = (this.adicionarClientesBusca || "").trim();
        if (q) {
          params.q = q;
        }
        const { data } = await axios.get(this.clientesElegiveisUrl(faseId), {
          headers: jsonHeaders,
          params,
        });
        if (seq !== this.adicionarClientesLoadSeq) {
          return;
        }
        const items = Array.isArray(data && data.data) ? data.data : [];
        const nextLista = reset ? items : (this.adicionarClientesLista || []).concat(items);
        this.$set(this, "adicionarClientesLista", nextLista);
        this.syncAdicionarClientesSelectedRows(items);
        this.adicionarClientesPage = Number(data.current_page) || page;
        this.adicionarClientesLastPage = Number(data.last_page) || 1;
        this.adicionarClientesErro = "";
      } catch (err) {
        if (seq !== this.adicionarClientesLoadSeq) {
          return;
        }
        if (reset) {
          this.$set(this, "adicionarClientesLista", []);
        }
        const msg =
          (err.response && err.response.data && err.response.data.message) ||
          "Não foi possível carregar os clientes.";
        this.adicionarClientesErro =
          typeof msg === "string" ? msg : "Não foi possível carregar os clientes.";
      } finally {
        if (seq === this.adicionarClientesLoadSeq) {
          this.adicionarClientesLoading = false;
        }
      }
    },
    async confirmAdicionarClientes() {
      const col = this.adicionarClientesCol;
      if (!col) {
        return;
      }
      const ids = Object.keys(this.adicionarClientesSelected)
        .filter((k) => this.adicionarClientesSelected[k])
        .map((k) => Number(k))
        .filter((id) => Number.isFinite(id) && id > 0);
      if (!ids.length) {
        return;
      }
      this.adicionarClientesSaving = true;
      try {
        const { data } = await axios.post(
          this.adicionarClientesPostUrl(col.id),
          { cliente_ids: ids },
          axiosSaveOptions,
        );
        const faseId = data.fase_id != null ? Number(data.fase_id) : Number(col.id);
        const cards = Array.isArray(data.cards) ? data.cards : [];
        for (const card of cards) {
          this.upsertClienteCard({
            visible: true,
            carteira_cliente_fase_id: faseId,
            card,
          });
        }
        await this.loadTotais();
        const ignorados = Number(data.ignorados) || 0;
        const adicionados = Number(data.adicionados) || cards.length;
        this.closeAdicionarClientesModal();
        if (ignorados > 0) {
          window.alert(
            `${adicionados} cliente(s) adicionado(s). ${ignorados} não puderam ser incluídos.`,
          );
        }
      } catch (_e) {
        window.alert("Não foi possível adicionar os clientes selecionados.");
      } finally {
        this.adicionarClientesSaving = false;
      }
    },
    onDragStart(card, evt) {
      this.draggingCliente = card;
      evt.dataTransfer.effectAllowed = "move";
    },
    moveCardToColumn(card, targetCol) {
      const found = this.findColumnWithCliente(card.id);
      const fromCol = found ? found.col : null;
      const targetKey = this.columnBoardKey(targetCol);
      const fromKey = fromCol ? this.columnBoardKey(fromCol) : null;
      this.removeClienteFromColumns(card.id);
      this.$set(
        targetCol,
        "items",
        this.sortKanbanColItemsArray([card, ...(targetCol.items || [])]),
      );
      if (fromCol && fromKey !== targetKey) {
        fromCol.total = Math.max(0, (Number(fromCol.total) || 0) - 1);
        targetCol.total = (Number(targetCol.total) || 0) + 1;
        (this.camposKanbanTotais || []).forEach((campoDef) => {
          const campoId = Number(campoDef.id);
          const valor = this.cardCampoNumericoValor(card, campoId);
          if (valor > 0) {
            this.adjustColTotaisCampo(fromCol, campoId, -valor);
            this.adjustColTotaisCampo(targetCol, campoId, valor);
          }
        });
      }
    },
    async onDrop(col, evt) {
      evt.preventDefault();
      if (!this.podeMoverCardsKanban || !this.draggingCliente) return;
      const card = this.draggingCliente;
      const clienteId = card.id;
      const found = this.findColumnWithCliente(clienteId);
      if (found && this.columnBoardKey(found.col) === this.columnBoardKey(col)) {
        this.draggingCliente = null;
        return;
      }
      const targetSemColuna = this.isSemColunaColumn(col);
      const rollback = found
        ? {
            fromColKey: this.columnBoardKey(found.col),
            fromItems: found.col.items.slice(),
            fromTotal: found.col.total,
            fromTotaisCampos: (found.col.totaisCampos || []).map((r) => ({ ...r })),
          }
        : null;
      const rollbackTarget = {
        items: col.items.slice(),
        total: col.total,
        totaisCampos: (col.totaisCampos || []).map((r) => ({ ...r })),
      };
      this.moveCardToColumn(card, col);
      this.draggingCliente = null;
      try {
        await axios.patch(
          this.atualizarFaseUrl(clienteId),
          {
            carteira_cliente_fase_id: targetSemColuna ? null : col.id,
          },
          axiosSaveOptions
        );
        await this.loadTotais();
        this.refreshClienteCard(clienteId).catch(() => {});
      } catch (e) {
        if (rollback) {
          const fromCol =
            rollback.fromColKey === SEM_COLUNA_KANBAN_ID
              ? this.semColunaColumn
              : this.columnsState.find((c) => this.columnBoardKey(c) === rollback.fromColKey);
          if (fromCol) {
            this.$set(fromCol, "items", rollback.fromItems);
            fromCol.total = rollback.fromTotal;
            fromCol.totaisCampos = (rollback.fromTotaisCampos || []).map((r) => ({ ...r }));
          }
        }
        this.removeClienteFromColumns(clienteId);
        this.$set(col, "items", rollbackTarget.items);
        col.total = rollbackTarget.total;
        col.totaisCampos = (rollbackTarget.totaisCampos || []).map((r) => ({ ...r }));
        window.alert("Não foi possível mover o cliente.");
      }
    },
    async openFaseModal(col) {
      this.faseFormError = "";
      if (col && this.podeGerenciarFasesUi) {
        try {
          const { data } = await axios.get(this.routes.fasesApi.index, { headers: jsonHeaders });
          const row = Array.isArray(data) ? data.find((f) => Number(f.id) === Number(col.id)) : null;
          if (row) {
            this.faseEditingId = row.id;
            this.faseForm = {
              nome: row.nome || "",
              cor: normalizeHexCor(row.cor),
              ordem: row.ordem != null ? row.ordem : null,
            };
          } else {
            this.faseEditingId = col.id;
            this.faseForm = {
              nome: col.nome || "",
              cor: normalizeHexCor(col.cor),
              ordem: col.ordem != null ? col.ordem : null,
            };
          }
        } catch (e) {
          this.faseEditingId = col.id;
          this.faseForm = {
            nome: col.nome || "",
            cor: normalizeHexCor(col.cor),
            ordem: col.ordem != null ? col.ordem : null,
          };
        }
      } else if (!col && this.podeGerenciarFasesUi) {
        this.faseEditingId = null;
        const maxOrdem = this.columnsState.reduce((acc, c) => Math.max(acc, c.ordem || 0), 0);
        this.faseForm = {
          nome: "",
          cor: randomFaseCor(this.columnsState.map((c) => c.cor)),
          ordem: maxOrdem + 1,
        };
      } else {
        return;
      }
      this.$nextTick(() => {
        bs$("#modalCarteiraKanbanFaseItem").modal("show");
      });
    },
    showFaseErrorModal({ title, message, errors }) {
      this.faseErrorModalTitle = title || "Atenção";
      this.faseErrorModalMessage = message || "";
      this.faseErrorModalItems = [];
      if (errors && typeof errors === "object" && !Array.isArray(errors)) {
        Object.keys(errors).forEach((key) => {
          const msgs = errors[key];
          const arr = Array.isArray(msgs) ? msgs : [msgs];
          const label = fieldLabel(key);
          arr.forEach((m) => {
            if (m != null && String(m).trim() !== "") {
              this.faseErrorModalItems.push({ label, text: String(m) });
            }
          });
        });
      }
      if (!this.faseErrorModalMessage && this.faseErrorModalItems.length) {
        this.faseErrorModalMessage = "Corrija os campos indicados abaixo.";
      }
      this.$nextTick(() => {
        bs$("#modalCarteiraKanbanFaseErro").modal("show");
      });
    },
    closeFaseErrorModal() {
      bs$("#modalCarteiraKanbanFaseErro").modal("hide");
    },
    openDeleteFaseModal(col) {
      this.faseDeleteTarget = col;
      this.faseDeleteLoading = false;
      const opcoes = this.columnsState.filter((c) => Number(c.id) !== Number(col.id));
      this.faseDeleteMigrarParaId = opcoes.length ? opcoes[0].id : null;
      this.$nextTick(() => {
        bs$("#modalCarteiraKanbanFaseExcluir").modal("show");
      });
    },
    closeDeleteFaseModal() {
      bs$("#modalCarteiraKanbanFaseExcluir").modal("hide");
      this.faseDeleteTarget = null;
      this.faseDeleteMigrarParaId = null;
    },
    openFaseOrdemModal() {
      if (!this.podeGerenciarFasesUi) {
        return;
      }
      this.faseOrdemDraft = this.sortFasesList(this.fasesLista).map((f) => ({
        id: f.id,
        nome: f.nome,
        cor: normalizeHexCor(f.cor),
        ordem: f.ordem != null ? f.ordem : 0,
      }));
      this.faseOrdemDragIndex = null;
      this.$nextTick(() => {
        bs$("#modalCarteiraKanbanFaseOrdem").modal("show");
      });
    },
    closeFaseOrdemModal() {
      bs$("#modalCarteiraKanbanFaseOrdem").modal("hide");
      this.faseOrdemDraft = [];
      this.faseOrdemDragIndex = null;
    },
    onFaseOrdemDragStart(index, evt) {
      if (!this.faseOrdemPodeArrastar) {
        evt.preventDefault();
        return;
      }
      this.faseOrdemDragIndex = index;
      if (evt.dataTransfer) {
        evt.dataTransfer.effectAllowed = "move";
        evt.dataTransfer.setData("text/plain", String(index));
      }
    },
    onFaseOrdemDragOver(evt) {
      evt.preventDefault();
      if (evt.dataTransfer) {
        evt.dataTransfer.dropEffect = "move";
      }
    },
    onFaseOrdemDrop(targetIndex, evt) {
      evt.preventDefault();
      const from = this.faseOrdemDragIndex;
      if (from === null || from === targetIndex) {
        this.faseOrdemDragIndex = null;
        return;
      }
      const draft = [...this.faseOrdemDraft];
      const [moved] = draft.splice(from, 1);
      draft.splice(targetIndex, 0, moved);
      this.faseOrdemDraft = draft;
      this.faseOrdemDragIndex = null;
    },
    onFaseOrdemDragEnd() {
      this.faseOrdemDragIndex = null;
    },
    async saveFaseOrdemModal() {
      if (!this.podeGerenciarFasesUi) {
        return;
      }
      const api = this.routes && this.routes.fasesApi;
      if (!api || !api.reorder) {
        window.alert("Não foi possível salvar a ordem das colunas.");
        return;
      }
      const currentIds = this.sortFasesList(this.fasesLista).map((f) => Number(f.id));
      const draftIds = this.faseOrdemDraft.map((f) => Number(f.id));
      if (
        currentIds.length === draftIds.length &&
        currentIds.every((id, i) => id === draftIds[i])
      ) {
        this.closeFaseOrdemModal();
        return;
      }
      this.faseOrdemSaving = true;
      try {
        const { data } = await axios.post(
          api.reorder,
          { fase_ids: draftIds },
          axiosSaveOptions,
        );
        bs$("#modalCarteiraKanbanFaseOrdem").modal("hide");
        this.mergeFasesFromApi(data);
        this.faseOrdemDraft = [];
        this.faseOrdemDragIndex = null;
      } catch (e) {
        const d = e.response && e.response.data ? e.response.data : {};
        const msg =
          (typeof d.message === "string" && d.message) ||
          "Não foi possível salvar a ordem das colunas.";
        this.showFaseErrorModal({ title: "Ordenar colunas", message: msg });
      } finally {
        this.faseOrdemSaving = false;
      }
    },
    async reloadFasesFromApi(options = {}) {
      const reloadCards = options.reloadCards === true;
      const { data } = await axios.get(this.routes.fasesApi.index, { headers: jsonHeaders });
      const { addedIds, removedIds } = this.mergeFasesFromApi(data);
      if (reloadCards || removedIds.length > 0) {
        await this.reloadAll();
        return;
      }
      if (addedIds.length > 0) {
        await this.loadTotais();
      }
    },
    async saveFaseModal() {
      if (!this.podeGerenciarFasesUi) return;
      this.faseFormError = "";
      const nome = (this.faseForm.nome || "").trim();
      if (!nome) {
        this.faseFormError = "Informe o nome da coluna.";
        this.$nextTick(() => {
          const input = document.getElementById("carteira-kanban-fase-nome");
          if (input) {
            input.focus();
          }
        });
        return;
      }
      const cor = normalizeHexCor(this.faseForm.cor);
      if (!/^#[0-9A-Fa-f]{6}$/.test(cor)) {
        this.faseFormError = "Informe uma cor válida (#RRGGBB).";
        return;
      }
      this.faseSaving = true;
      try {
        const payload = {
          nome,
          cor,
          ordem:
            this.faseForm.ordem === null || this.faseForm.ordem === ""
              ? null
              : Number(this.faseForm.ordem),
          ativo: true,
        };
        const api = this.routes.fasesApi;
        const updateUrl = normalizeApiBase(api.base);
        let savedFase = null;
        if (this.faseEditingId) {
          const { data } = await axios.put(
            `${updateUrl}/${this.faseEditingId}`,
            payload,
            axiosSaveOptions,
          );
          savedFase = data;
        } else {
          const { data } = await axios.post(api.store, payload, axiosSaveOptions);
          savedFase = data;
        }
        bs$("#modalCarteiraKanbanFaseItem").modal("hide");
        if (this.faseEditingId) {
          this.updateFaseInState(savedFase);
        } else {
          this.appendFaseToState(savedFase);
          await this.loadTotais();
        }
      } catch (e) {
        const d = e.response && e.response.data ? e.response.data : {};
        if (e.response && e.response.status === 422) {
          const nomeErrors = d.errors && Array.isArray(d.errors.nome) ? d.errors.nome : [];
          this.faseFormError =
            nomeErrors[0] ||
            d.message ||
            "Corrija os dados da coluna antes de salvar.";
          if (nomeErrors.length) {
            this.$nextTick(() => {
              const input = document.getElementById("carteira-kanban-fase-nome");
              if (input) {
                input.focus();
              }
            });
          }
        } else {
          const msg =
            (typeof d.message === "string" && d.message) ||
            (typeof d.error === "string" && d.error) ||
            "Não foi possível salvar.";
          this.faseFormError = typeof msg === "string" ? msg : JSON.stringify(msg);
        }
      } finally {
        this.faseSaving = false;
      }
    },
    async executeDeleteFase() {
      if (!this.faseDeleteTarget || !this.podeGerenciarFasesUi) {
        this.closeDeleteFaseModal();
        return;
      }
      const id = this.faseDeleteTarget.id;
      const migrarParaId =
        this.faseDeleteMigrarParaId && this.faseDeleteDestinoOpcoes.length > 0
          ? Number(this.faseDeleteMigrarParaId)
          : null;
      const enviarMigracao = migrarParaId != null && migrarParaId > 0;
      if (this.faseDeleteTarget.total > 0 && !enviarMigracao) {
        return;
      }
      this.faseDeleteLoading = true;
      try {
        const base = normalizeApiBase(this.routes.fasesApi.base);
        const config = { headers: jsonHeaders, maxRedirects: 0 };
        if (enviarMigracao) {
          config.data = { migrar_para_fase_id: migrarParaId };
        }
        await axios.delete(`${base}/${id}`, config);
        this.closeDeleteFaseModal();
        this.removeFaseFromState(id);
        await this.loadTotais();
        if (enviarMigracao) {
          const destCol = this.columnsState.find((c) => Number(c.id) === migrarParaId);
          if (destCol) {
            destCol.page = 1;
            destCol.items = [];
            destCol.hasMore = false;
            await this.loadPage(destCol, 1, true);
          }
        }
      } catch (e) {
        this.closeDeleteFaseModal();
        const d = e.response && e.response.data ? e.response.data : {};
        this.showFaseErrorModal({
          title: "Exclusão",
          message:
            (typeof d.message === "string" && d.message) || "Não foi possível excluir esta coluna.",
        });
      } finally {
        this.faseDeleteLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.carteira-cadastros-vue__error-list li + li {
  margin-top: 0.35rem;
}
</style>
